import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import { ApiService } from '../../../../api.service';
import { MapSyncProcess, UnitById, getDeviceById } from '../../../../api';
import { AlertSharedService } from '../../../../_services/index';
import { appsettings, DeviceTypeDesc, enumRequestFrom, NewDeviceTypeDesc,DeviceType, enumTech_rightmenu_Tool, enumUIFeatureView, enumUIAction, enumUIView, fillcolorPolygon } from '../../../../app-settings';
import { ZoneByID, addHRexflag, TechnologyForCreationResponse,deleteUnitById,getDeviceDetailsReq, getPolylineRequest,getSiteAuthKeyReuest,CampusByID, getTemplates } from '../../technologyoverlay';
import { TechnologyoverlayService } from '../../technologyoverlay.service';
import { DOCUMENT } from '@angular/platform-browser';
import OlMap from 'ol/Map';
import { SessionCheck,  generateAlertMessage, getFeatureNeedtoShow, AuthFailedMessage,   map_widthandheight, getCheckInExtent, LoadTechnologyFloorSvg, convertToSvgEcllipseXCoordinate, convertToSvgEcllipseYCoordinate, maponclicked_Tech, Checkpolygon_Intersect, get_selectedfeature, getNewFeature, mouseOnFeature,calculateCenter, IsCheckRoomDrawn, IsDevice_In_RoomDrawn, ClearStorageSpaceData, getSelected} from '../../../../app-general';
import { map_creation, fillcolor_style, label_Polygon, get_geojsonObject_floor,   fillcolor_styleSelect, getDeviceTypeNew } from '../../../../map-general';
import { Circle as CircleStyle, Icon, Style, Fill, Stroke, Text } from 'ol/style';
import {  MatDialog,  MatDialogRef } from '@angular/material';
import { ConfirmMessageComponent } from '../../../../confirm-message/confirm-message.component';
import { AddDeviceComponent } from '../../device/add-device/add-device.component';
import { FormGroup } from '@angular/forms';
import { AddUnitComponent } from '../unit/add-unit/add-unit.component';
import { EditDeviceComponent } from '../../device/edit-device/edit-device.component';
import { InsertTemplateComponent } from '../mapview-floor/insert-template/insert-template.component';
import { DuplicateUnitComponent } from '../unit/duplicate-unit/duplicate-unit.component';
import { TemplateUnitComponent } from '../unit/template-unit/template-unit.component';
import { TemplateZoneComponent } from '../zone/template-zone/template-zone.component';
import { EditZoneComponent } from '../zone/edit-zone/edit-zone.component';
import { EditUnitComponent } from '../unit/edit-unit/edit-unit.component';
import { GeneralMessageComponent } from './../../../../general-message/general-message.component';
import {MultiPoint, Point} from 'ol/geom';

import Draw, {
  createBox,
  createRegularPolygon,
} from 'ol/interaction/Draw';

import {
  Modify,
  Select,
  Translate,
  defaults as defaultInteractions,
  Pointer as PointerInteraction,
} from 'ol/interaction';
import {
  never,
  platformModifierKeyOnly,
  primaryAction,
  shiftKeyOnly,
  singleClick
} from 'ol/events/condition';
import 'ol-popup/src/ol-popup.css';
import OlVectorLayer from 'ol/layer/Vector';
import { OSM, Vector as VectorSource } from 'ol/source';
import { style } from '@angular/animations';

@Component({
  selector: 'app-mapview-floor',
  templateUrl: './mapview-floor.component.html',
  styleUrls: ['./mapview-floor.component.scss']
})

export class MapviewFloorComponent implements OnInit {

  bAddEdit: boolean = false;
  bDelete: boolean = false;
  bAddEditTemplate: boolean = false;
  imageExtent;
  checkroomdrawend = false;

  buildingcampusname = '';
  buildingcampusfullname = '';
  floorbuildingname = '';
  floorbuildingfullname = '';
  unitfloorname = '';
  unitfloorfullname = '';
  roomunitname = '';
  roomunitfullname = '';

  selectedcampus = 0;
  selectedbuilding = 0;
  selectedfloor = 0;
  selectedunit = 0;

  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  dialogResult = "";
  displayedColumnsRoom: string[] = ['DeviceType', 'DeviceId', 'LforIr', 'MacId', 'DeviceName'];
  dataSourceRoom;

  campusImgUrl: string = appsettings.CAMPUS_IMAGE_FOLDER;
  floorImgUrl: string = appsettings.FLOOR_IMAGE_FOLDER;

  watcher: Subscription;
  columns: number = 4;

  buildflag: number = 0;
  editflag: number = 0;
  formCampusId;
  addcampusid;
  addbuildingid;
  addfloorid;
  svgimageurl = 0;

  FacilityImgurl: string = appsettings.Facility_IMAGE_FOLDER;
  FacilityName;
  campuseditdialogopen = 0;
  buildeditdialogopen = 0;
  flooreditdialogopen = 0;
  uniteditdialogopen = 0;
  IsDuplicateAdded = 0;
  MapSyncProcess;
  editdialogfacilityopen = 0;
  SiteId = "1";

  campusimagename;
  campusaddImgUrl;
  validcampusimgurl;
  CampusCnt = 0;
  BuildingCnt = 0;
  FloorCnt = 0;
  UnitCnt = 0;
  Importflag = 0;
  importHeaders;
  getselectedmapdetails;

  imgSrc;
  clseditimg;

  getfloordata;
  MCampusId;
  MBuildingId;
  MFloorId;
  CampusFulldetails: any[];
  selectedCampus;
  selectedBuilding;
  selectedFloor;
  
  CampusImageURL = "";
  BuildingImageURL = "";
  FloorImageURL = "";
  SvgImageUrl = "";
  campusName;
  FloorInfo;
  buildDuplicatedialogopen = 0;
  ImageWidth = "";
  ImageHeight = "";
  addfloorimageheight = 0;
  ImageUrl = "";
  BackgroundIMG = "Centrak";
  Check_ZoomLevel;
  Check_MapCenter;
  CZoomLevel;
  CRotateLevel;
  TranslateX;
  TranslateY;
  SvgInfo = null;
  map = new OlMap();
  Floor_Name;
  Building_Name;
  Campus_Name;
  UnitByIddetails;
  buttontext;
  checkIsSpace = false;
  CheckIsAdd = false;
  checkIsEdit = false;
  checkIsEditOpen = false;
  adddeviceflag = 0;
  rotateIsInside = 1;

  collapsedIcon1 = "keyboard_arrow_down";
  collapsedIcon = "keyboard_arrow_down";

  collapsedIcon1_build = "keyboard_arrow_up";
  collapsedIcon_build = "keyboard_arrow_up";

  collapsedIcon1_floor = "keyboard_arrow_up";
  collapsedIcon_floor = "keyboard_arrow_up";

  collapsedIcon1_unit = "keyboard_arrow_up";
  collapsedIcon_unit = "keyboard_arrow_up";

  checkicon;
  preId = -1;
  arrowiconT = true;
  arrowiconF = false;

  build_arrowiconT = true;
  build_arrowiconF = false;

  floor_arrowiconT = true;
  floor_arrowiconF = false;

  unit_arrowiconT = true;
  unit_arrowiconF = false;

  camp_isbuttonshow = 0;
  build_isbuttonshow = 0;
  floor_isbuttonshow = 0;

  selectedBuildingdetails = {};
  selectedFloordetails = {};

  Campus_key = 'Campusinfo';
  Building_key = 'Buildinginfo';
  Floor_key = 'Floorinfo';
  chkbuildmapflag = 0;
  devicefiltervalue = "";
  devicefiltervalue_mapdetail;
  Map_array_length = 3;
  device_list_all = "3";

  selected_floorId = 0;
  selected_buildId = 0;
  selected_campusId = 0;
  getMap_flag = 0;

  editimageheight;
  editimagewidth;
  Map_image_path = 'assets/images/';
  filterdevicedetails;

  Device_Info;
  Total_DeviceInfo;
  Selected_DeviceTypename;
  Selected_ImageDeviceTypename;
  SelDeviceInfo;

  Edit_FloorById;

  //Draw feature for Room
  vector = new OlVectorLayer();
  source = new VectorSource({ wrapX: false });
  vectorLayer = new OlVectorLayer({
    source: this.source
  });

  draw = new Draw({
    source: this.source,
    type: "Polygon"
  });
  getDeviceList_info;
  checksortflag = 0;
  adddevicedialogopen = 0;
  Device_Details;
  selectedsortType = 0;
  Tech_Devicelist=enumTech_rightmenu_Tool.DeviceList;
  Tech_Move=enumTech_rightmenu_Tool.Move;
  Tech_Create_Space=enumTech_rightmenu_Tool.Create_Space;
  Tech_Edit_Space=enumTech_rightmenu_Tool.Edit_Space;
  Tech_Add_Device=enumTech_rightmenu_Tool.Add_Device;
  Tech_Duplicate_Space=enumTech_rightmenu_Tool.Duplicate_Space;
  Tech_Insert_Template=enumTech_rightmenu_Tool.Insert_Template;
  Tech_Delete_Space=enumTech_rightmenu_Tool.Delete_Space;

  
  Tech_Rectangle_Space=enumTech_rightmenu_Tool.Rectangle_Space;
  Ellipse_Space=enumTech_rightmenu_Tool.Ellipse_Space;
  FreeHand_Space=enumTech_rightmenu_Tool.FreeHand_Space;
  Edit_Point=enumTech_rightmenu_Tool.Edit_Point;
  Rotate_Space=enumTech_rightmenu_Tool.Rotate_Space;
  Reflect_Space=enumTech_rightmenu_Tool.Reflect_Space;

  private _onDestroy: Subject<void> = new Subject<void>();
  public _NewDeviceTypeDesc = NewDeviceTypeDesc;
  
  Edit_pointsbool = true;
  insertTemplatebool = false;

  constructor(private router: Router, private apiService: ApiService, private alertSharedService: AlertSharedService, @Inject(DOCUMENT) private document: any, public dialog: MatDialog,
    public thisDialogRef: MatDialogRef<MapviewFloorComponent>, private technologyoverlayService: TechnologyoverlayService, private dialogRef: MatDialog) {
    if(this.router.getCurrentNavigation().extras.state != undefined)
    localStorage.setItem("MapviewFloorComponent",JSON.stringify(this.router.getCurrentNavigation().extras.state));
    
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }   
    
  }

  DeviceSorting: any[] = [
    { Name: 'Complete', Value: "1" },
    { Name: 'Incomplete', Value: "2" },
    { Name: 'Space ascending', Value: "3" },
    { Name: 'Space descending', Value: "4" },
  ];

  ngOnInit() {
   

    this.dialogRef.closeAll();
    this.getfloordata = JSON.parse(localStorage.getItem("MapviewFloorComponent"));

    localStorage.setItem("CreateNew", "0");    
    if(this.bAddEdit == true)
    {      
      var saveBtn = document.getElementById("btnsaveclickmapview");      
      if(saveBtn != null)
      {
        saveBtn.className = 'clsdeviceaddbutton mat-raised-button';
        saveBtn.innerHTML = "Save";
        this.buttontext = "Save";
      }
    }    
    this.Campus_Name = this.getfloordata.CampusName;
    this.Building_Name = this.getfloordata.BuildingName;
    this.Floor_Name = this.getfloordata.FloorName;
    document.getElementById("spnfloorName").innerHTML = this.getfloordata.FloorName;
    document.getElementById("hdFloorName").innerHTML = this.getfloordata.FloorName;
    
    this.addcampusid = this.getfloordata.CampusId;
    this.addbuildingid = this.getfloordata.BuildId;
    this.addfloorid = this.getfloordata.FloorId;
    this.getDeviceDetails();
    this.selectCampusFull();
    this.getHRexdetails();
    localStorage.setItem("Spaceedit", "0");
    localStorage.setItem("SpaceId", "0");
    localStorage.setItem("SpaceName", "");
    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
      this.bAddEdit = true;
      this.bDelete = true;
    }  
    else
    {
      this.DisableBtn();
    }

    if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Templates_AddEditDelete) == enumUIView.Show) {
      this.bAddEditTemplate = true;
    }  
    this.getgatewaymacid = localStorage.getItem('applianceSN');

    if (this.getgatewaymacid.indexOf("_") == -1) {
      this.getgatewaymacid = this.getgatewaymacid.replace(/(.{2})/g, "$1_").slice(0, -1);
    }

  }

  getHRexdetails() {
    try {
      let hrexdetails :getSiteAuthKeyReuest = { siteId: this.SiteId, authKey: localStorage.getItem("Authkey") };
      this.technologyoverlayService.getHRexdetails(hrexdetails).pipe(takeUntil(this._onDestroy))
        .subscribe((HRexDetails: any[]) => {
          if (HRexDetails != null && HRexDetails != undefined) {
            this.getHRexMacId = HRexDetails;
          }
        })
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - getHRexdetails() - ' + err.message);
    }
  }

  getHrexflag() {
    if (this.addfloorid != 0) {
      var hrexItem :getSiteAuthKeyReuest = { siteId: this.SiteId, authKey: localStorage.getItem("Authkey") }
      this.technologyoverlayService.checkHREXfound(hrexItem).pipe(takeUntil(this._onDestroy))
        .subscribe((addHRexflag: any[]) => {
          this.addHRexflag = addHRexflag;
        });

    }
  }

  getMaxRexdevicedetail() {
    var rexItem :getSiteAuthKeyReuest = { siteId: this.SiteId, authKey: localStorage.getItem("Authkey") }
    this.technologyoverlayService.getRexdevicedetails(rexItem).pipe(takeUntil(this._onDestroy))
      .subscribe((maxrexvalue: any[]) => {
        
        this.MaxRexvalue = maxrexvalue[0].DeviceId;
      });
  }

  selectCampusFull() {

    try {

      let campusid: CampusByID = {
        siteId: this.getfloordata.SiteId.toString(),
        authKey: localStorage.getItem("Authkey"),
        campusId: parseInt(this.addcampusid)
      }
      
      var item;

      this.apiService.getCampusbyCampusId(campusid).pipe(takeUntil(this._onDestroy))
        .subscribe((CampusFulldetails: any[]) => {

          // need to latest campus from sysc need to show the global alert start
          var CheckAlertData = {
            "IsAlertChanged": 0,
            "IsAlertClicked": 0
          };
          this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
          CheckAlertData = {
            "IsAlertChanged": 1,
            "IsAlertClicked": 0
          };
          this.alertSharedService.changeSharedCheckAlert(CheckAlertData);
          // need to latest campus from sysc need to show the global alert end

          
          this.CampusFulldetails = CampusFulldetails;

          var _SharedHomeMapDetails = {
            "sel_CampusId": this.addcampusid,
            "sel_BuildingId": this.addbuildingid,
            "sel_FloorId": this.addfloorid
          };

          this.alertSharedService.changeSharedHomeMapdetails(_SharedHomeMapDetails);

          var mapdetail = this.addcampusid + "_" + this.addbuildingid + "_" + this.addfloorid;
          
          this.CampusFulldetails["SelectedMapInfo"] = mapdetail;
          item = { SiteId: this.addcampusid, MapDetails: this.CampusFulldetails };
          this.getMapDetails(item);
        });
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts - selectCampusFull() - ' + err.message);
    }
  }

  getMapDetails(MapDetails): void {

    var arrMapDetails = "";
    var BulidingId;
    var FloorId;
    var CampusId;
    if (MapDetails.MapDetails.SelectedMapInfo != "0_0_0") {

      arrMapDetails = MapDetails.MapDetails.SelectedMapInfo.split('_');
      this.CampusFulldetails = MapDetails.MapDetails;

      this.CampusFulldetails = MapDetails.MapDetails;
      CampusId = arrMapDetails[0];
      BulidingId = arrMapDetails[1];
      FloorId = parseInt(arrMapDetails[2]);

      for (var info = 0; info <= this.CampusFulldetails["Campusinfo"].length - 1; info++) {
        if (this.CampusFulldetails["Campusinfo"][info]["CampusId"] == CampusId) {
          for (var build = 0; build <= this.CampusFulldetails["Campusinfo"][info]["Campusdetail"].length - 1; build++) {
            if (this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].buildingid == BulidingId) {
              for (var floor = 0; floor <= this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors.length - 1; floor++) {
                if (this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].floorid == FloorId) {
                  this.FloorImageURL = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].FloorPlanImage;
                  this.ImageWidth = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].ImageWidth;
                  this.ImageHeight = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].ImageHeight;
                  this.CZoomLevel = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].FZoomLevel;
                  this.CRotateLevel = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].FRotateLevel;
                  this.TranslateX = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].FTranslateX;
                  this.TranslateY = this.CampusFulldetails["Campusinfo"][info].Campusdetail[build].floors[floor].FTranslateY;
                  this.ImageUrl = appsettings.FLOOR_IMAGE_FOLDER + "/" + this.FloorImageURL;
                  this.SvgInfo = null;
                  this.FloorInfo = null;
                  this.getDeviceDetails();
                  this.DrawMapCall();
                  break;
                }
              }
              break;
            }
          }
          break;
        }
      }

    }
  }

  DrawMapCall() {
    try {
      //Map Empty
      let element = this.document.getElementById('map');
      var IsZoomChanged = 0;
      if(element.innerHTML != "" && (this.Check_ZoomLevel || this.Check_ZoomLevel == 0))
      {
        this.CZoomLevel = this.Check_ZoomLevel;
        IsZoomChanged = 1;
      }
      else{
        this.Check_MapCenter = [];
      }
      element.innerHTML = '';
      var leftmenu = document.getElementById("leftmenu1");
      leftmenu.classList.add("active");
      ///Map width and height
      let imgwh = map_widthandheight(this.ImageWidth, this.ImageHeight);
      var imgwidth = imgwh.ImageWidth;
      var imgheight = imgwh.ImageHeight;
      this.addfloorimageheight = imgwh.ImageHeight;

      // Polygons style
      var labelStyle = label_Polygon(0);
      var fillcolorStyle = fillcolor_style(fillcolorPolygon.Incomplete);
      var style = [fillcolorStyle, labelStyle];

      var devicelabelStyle = new Style({

        text: new Text({
          font: '10px Poppins, sans-serif',
          overflow: true,
          fill: new Fill({
            color: '#000'
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 5
          }),
          offsetX: 0,
          offsetY: 25.5
        })
      });

     
      var deviceStyle = fillcolor_style(fillcolorPolygon.Completed);

      var fillStyle = [deviceStyle, devicelabelStyle];
      this.map = map_creation(this.ImageUrl, imgwidth, imgheight, true, this.BackgroundIMG, this.CZoomLevel, this.CRotateLevel, element.offsetWidth, element.offsetHeight, this.TranslateX, this.TranslateY, 'map', this.Check_MapCenter, IsZoomChanged);


      var translateX = this.TranslateX;
      var translateY = this.TranslateY;

      translateX = translateX / 122;
      translateY = translateY / 127;

      translateX = translateX * imgwidth;
      translateY = translateY * imgheight;

      var _map = this.map;
      var MapCenter = _map.getView().getCenter();

      MapCenter[0] -= translateX;
      MapCenter[1] += translateY;

      if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Show) {
        maponclicked_Tech(this.map, this.select, this.addfloorid, this.technologyoverlayService, this._onDestroy, this.edit_DeviceDetails, this.dialog, this,this.editunitopendialog);
      }

      var _this = this;    
      var currZoom =  _this.CZoomLevel;
      _map.on('moveend', function (e) {
        if(IsZoomChanged == 0)
        getCheckInExtent(e, _map, imgwidth, imgheight, MapCenter);
        var newZoom = _map.getView().getZoom();
        if (currZoom != newZoom) {
          
          currZoom = newZoom;
          _this.CZoomLevel = newZoom;
          _this.Check_ZoomLevel = newZoom;
          _this.Check_MapCenter = _map.getView().getCenter();
        }
      });

      _map.on('pointermove', function() {
        _this.Check_MapCenter = _map.getView().getCenter();
      });

      //////////Floor Devices Start////////////

      var arrdevicemarker = [];
      var arrdevicemarkernoPoly = [];
      if (this.FloorInfo != null) {
        /// Geo Feature Collection ///
        var geoFloorjsonObject = get_geojsonObject_floor(enumRequestFrom.floorplan_page);
        geoFloorjsonObject.type = "FeatureCollection";

        var arrgeoFloorjsonObject = geoFloorjsonObject.features; // empty Object
        geoFloorjsonObject.features.length = 0;

        /// marker array ///
        var arrmarker = [];
        if (this.FloorInfo.length > 0) {
          var arrFloorInfo = this.FloorInfo;
          LoadTechnologyFloorSvg(this.map, arrFloorInfo, imgheight, imgwidth, arrdevicemarker, geoFloorjsonObject, arrdevicemarkernoPoly, devicelabelStyle, fillStyle, this.Map_image_path, this.addfloorid,1);
          this.editimageheight = imgheight;
          this.editimagewidth = imgwidth;
      
        }
        else if (this.FloorImageURL == null) {
          document.getElementById("map").innerHTML = "<span style='margin-top: 15%; padding-left: 45%;display:block;font-size:15px;font-weight:bold;'> Map Not Found.</span>";
        }
        
        if (this.IsDuplicateAdded == -1) {
          _this.select_move(this.IsDuplicateAdded);
        }
        else if (this.IsDuplicateAdded != 0) {
          var _this = this;

          var _UnitId = this.IsDuplicateAdded.toString();
          var _addfloorid = this.addfloorid;
          var arr_layer = [];
          this.map.getLayers().forEach(function (Floorlayer) {
            if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + _addfloorid) {
              arr_layer[arr_layer.length] = Floorlayer;
            }
          });
          var arrduplicate_feature = [];
          for (var indx = 0; indx < arr_layer.length; indx++) {
            var features_device = arr_layer[indx].getSource().getFeatures();
            if (features_device) {
              // Go through this array and get coordinates of their geometry.
              features_device.forEach(function (feature) {
                if (parseInt(feature.getProperties().UnitId) == parseInt(_UnitId)
                  && (feature.getProperties().geometry.flatCoordinates.length != 2)) {
                  arrduplicate_feature[arrduplicate_feature.length] = feature;
                }
                else if (parseInt(feature.getProperties().UnitId) == parseInt(_UnitId)
                  && (feature.getProperties().geometry.flatCoordinates.length == 2)) {
                  arrduplicate_feature[arrduplicate_feature.length] = feature;
                }
              });
            }
          }

          _this.select_move(arrduplicate_feature)
        }
      }
      //////////Floor Devices End////////////
    
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts - DrawMapCall() - ' + err.message);
    }

  }

  getDeviceDetails() {

    try {
      let voiceLicense = localStorage.getItem("voice_license");
      var devicedata:getDeviceDetailsReq = 
      { 
        siteId: this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:this.MCampusId,
        floorId: parseInt(this.addfloorid),
        status:  this.device_list_all,
        devicetype: 0,
        device: 0, 
        spaceId: 0,
        isIndoor:1,
        isNeedRoomonly:1,
        isNeedIntercom : parseInt(voiceLicense)
      };

      this.apiService.getDeviceDetails(devicedata).pipe(takeUntil(this._onDestroy))
        .subscribe((DeviceDetails: any[]) => {
          
          if (DeviceDetails != null && DeviceDetails != undefined) {
            if (DeviceDetails["apiReturn"] == "Authfalse") {
              AuthFailedMessage(this.dialog, this.router);
              return;
            }
            this.filterdevicedetails = DeviceDetails["apiReturn"];
            //this.dataSource = new MatTableDataSource(DeviceDetails);
            DeviceDetails["apiReturn"].forEach(function (e) {
              if (e.DeviceName == DeviceTypeDesc.Emitter) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Emitter;
              }
              else if (e.DeviceName == DeviceTypeDesc.HRex) {
                e['NewDeviceName'] = NewDeviceTypeDesc.HRex;
              }
              else if (e.DeviceName == DeviceTypeDesc.Rex) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Rex;
              }
              else if (e.DeviceName == DeviceTypeDesc.LF) {
                if (e.SubType==DeviceType.DripTray)
                 {
                   e['NewDeviceName'] = NewDeviceTypeDesc.DripTray;
                 }
                 else
                 {
                e['NewDeviceName'] = NewDeviceTypeDesc.LFExiter;
                }
              }
              else if (e.DeviceName == DeviceTypeDesc.Pullcord) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Pullcord;
              }
              else if (e.DeviceName == DeviceTypeDesc.DC  || e.DeviceName == DeviceTypeDesc.NewDC) {
                e['NewDeviceName'] = NewDeviceTypeDesc.DC;
              }
              else if (e.DeviceName == DeviceTypeDesc.Monitor) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Monitor;
              }
              else if (e.DeviceName == DeviceTypeDesc.VW) {
                e['NewDeviceName'] = NewDeviceTypeDesc.VW;
              }
              else if (e.DeviceName == DeviceTypeDesc.Gateway) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Gateway;
              }
              else if (e.DeviceName == DeviceTypeDesc.UT) {
                e['NewDeviceName'] = NewDeviceTypeDesc.UT;
              }
              else if (e.DeviceName == DeviceTypeDesc.UM) {
                e['NewDeviceName'] = NewDeviceTypeDesc.UM;
              }
              else if (e.DeviceName == NewDeviceTypeDesc.Room) {
                e['NewDeviceName'] = NewDeviceTypeDesc.Room;
              }
              else if (e.DeviceName == DeviceTypeDesc.Intercom) {
                e['NewDeviceName'] = DeviceTypeDesc.Intercom;
              }
              else {
                e['NewDeviceName'] = NewDeviceTypeDesc.Zone;
              }
            })
            this.Device_Info = DeviceDetails["apiReturn"];
            let DeviceList_array = [];
            DeviceDetails["apiReturn"].forEach(function (data) {
              if (data.FilterDeviceType != NewDeviceTypeDesc.Room) {
                var newData = {};
                newData['DeviceId'] = data.DeviceId;
                newData['DeviceTypeId'] = data.DeviceTypeId;
                newData['NewDeviceName'] = data.NewDeviceName;
                newData['UnitLocation'] = data.UnitLocation;
                newData['DataId'] = data.DataId;
                newData['UnitId'] = data.UnitId;
                newData['Description'] = data.Description;
                if (data.DeviceId > 0 || data.DeviceName == DeviceTypeDesc.Gateway)
                  newData['Status'] = 'Active';
                else if (data.DeviceId == 0)
                  newData['Status'] = 'Inactive';
                DeviceList_array.push(newData);
              }
            })
            this.getDeviceList_info = DeviceList_array;
            this.Total_DeviceInfo = this.getDeviceList_info.length;
            this.Device_Details = DeviceDetails["apiReturn"];
            if (this.selectedsortType != 0){
              this.selectDeviceSort(this.selectedsortType);
            }           

            this.FloorInfo = DeviceDetails["apiReturn"];            
            this.DrawMapCall();            
          }
        });
    }
    catch (err) {
      throw new Error('device.component.ts' + ' - getDeviceDetails() - ' + err.message);
    }
  }

  //When we click the device list it will show the list of devices available in the Floor.
  device_list() {
    var elem = document.getElementById('container_CreateSpace');
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_DeviceList;
    if (elem.classList.contains('enablebtn')) {
      this.DisableButton("container_DeviceList");
      if (document.getElementById('divDeviceList').style.display == "none") {
        document.getElementById('divDeviceList').style.display = "block";
      }
      else {
        document.getElementById('divDeviceList').style.display = "none";
      }
    }
    else {
      this.ResetButton();
    }
    this.ClearInteraction();
    
  }

  //When we click the Add space it will open up the option to draw. We have 3 options to draw the polygon .
  create_space() {
    var elem = document.getElementById('container_DeviceList');
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Create_Space;
    if (elem.classList.contains('enablebtn')) {
      localStorage.setItem("CreateNew", "0");
      this.checkIsSpace = true;
      this.checkIsEdit = false;
      var saveBtn = document.getElementById("btnsaveclickmapview");
      saveBtn.innerHTML = "Done";
      this.DisableButton("container_CreateSpace");

      if (document.getElementById('divCreateSpaceMenu').style.display == "none") {
        document.getElementById('divCreateSpaceMenu').style.display = "block";
      }
      else {
        document.getElementById('divCreateSpaceMenu').style.display = "none";
      }
    }
    else {
      // document.getElementById("mouseovertext").innerHTML = " ";
      this.ResetButton()
    }
    this.ClearInteraction();
  }

  //Edit space will open the option to edit the space point or we can redraw the space by adding more points.
  edit_space() {
    var elem = document.getElementById('container_DeviceList');
    
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Edit_Space;
    if (elem.classList.contains('enablebtn')) {
      if (document.getElementById('divEditSpaceMenu').style.display == "none") {
        document.getElementById('divEditSpaceMenu').style.display = "block";
      }
      else {
        document.getElementById('divEditSpaceMenu').style.display = "none";
      }
      var saveBtn = document.getElementById("btnsaveclickmapview");
      // if (saveBtn.innerHTML == "Done") saveBtn.innerHTML = "Save";
      saveBtn.innerHTML = "Done";
      this.DisableButton("container_EditSpace")
    }
    else {
      this.ResetButton();
    }
    this.ClearInteraction();
  }

  //Click and drag to draw your Rectangle space, then move it on the map.
  draw_rectangle() {
    document.getElementById('divCreateSpaceMenu').style.display = "none";
    var geometryFunction = createBox();
    this.DrawFeature("Circle", geometryFunction);
  }

  draw_ellipse() {
    document.getElementById('divCreateSpaceMenu').style.display = "none";
    var geometryFunction = createRegularPolygon(20);
    this.DrawFeature("Circle", geometryFunction);
  }

  //Click and drag to draw your Free handed line drawing, then move it on the map.
  draw_freehand() {
    document.getElementById('divCreateSpaceMenu').style.display = "none";
    this.DrawFeature("Polygon", null);
  }

  checkdrawroomflag = 0;
  drawroomselect;
  
  Buildingsvgid = 0;
  Buildingdetails: any[];


  select = null;
  modify = null;
  translate = null;
  _translateend = 0;
  select_Feature;
  selectName_Feature;
  selectedFeature;
  selectedNameFeature;
  //Draw feature for Devices Polygon
  DrawFeature(DrawFeature_Type, geometryFunction) {
    var arr_Layers = this.map.getLayers();
    this.imageExtent = arr_Layers.array_[0].getSource().getImageExtent();

    this.checkdrawroomflag = 1;
    this.drawroomselect = 1;

    var fillcolorStyle = fillcolor_styleSelect();
    this.tempVectorSource.clear();
    this.map.removeInteraction(this.draw);
    var drawRoomSource;
    function onDrawStart(event) {
      //remove everything drawn previously
      drawRoomSource.clear();
      event.feature.setStyle(fillcolorStyle);
    }

    if (geometryFunction != null) {
      this.draw = new Draw({
        source: this.source,
        type: DrawFeature_Type,
        geometryFunction: geometryFunction
      });
    }
    else {
      this.draw = new Draw({
        source: this.source,
        type: DrawFeature_Type
      });
    }
    this.draw.on('drawstart', onDrawStart);

    drawRoomSource = this.source;

    this.vector = new OlVectorLayer({
      source: this.source
    });

    this.vector.setStyle(fillcolorStyle);
    this.vector.set('extent', this.imageExtent);

    this.map.addInteraction(this.draw);
    this.map.addLayer(this.vector);

    // Get the array of features
    var features = this.vector.getSource().getFeatures();
    if (features != undefined) {
      // Go through this array and get coordinates of their geometry.
      features.forEach(function (feature) {

      });
    }

    var checkdraw;
    var _this = this;
    var _addfloorimageheight = this.addfloorimageheight;
    
    this.draw.on('drawend', function (e) {
      checkdraw = IsCheckRoomDrawn(e.feature, _this, 0);
      if(checkdraw == true)
      {
        Checkpolygon_Intersect(_this.map, _this.dialog, _this, e.feature, _this.addfloorid, _addfloorimageheight);
      }
    });
    this.checkroomdrawend = checkdraw;
  }

  Edit_Points() {
    if (!SessionCheck(this.router)) {
      return;
    }
    document.getElementById('divEditSpaceMenu').style.display = "none";
    this.checkIsEdit = true;
    this.checkIsSpace = false;
    localStorage.setItem("Spaceedit", "0");
    localStorage.setItem("CreateNew", "3");
    var arr_Layers = this.map.getLayers();
    this.imageExtent = arr_Layers.array_[0].getSource().getImageExtent();
    document.getElementById('divEditSpaceMenu').style.display = "none";

    this.DisableButton("container_EditSpace");

    this.map.getInteractions().forEach((interaction) => {
      if (interaction instanceof Translate) {
        interaction.getFeatures().clear()
      }
      if (interaction instanceof Select) {
        interaction.getFeatures().clear()
      }
    });

    if (!SessionCheck(this.router)) {
      return;
    }
   

    this.checkdrawroomflag = 1;
    this.drawroomselect = 1;
    this.tempVectorSource.clear();

    var fillcolorStyle = fillcolor_styleSelect();

    var _map = this.map;
    var arr_layer = [];
    var _addfloorid = this.addfloorid;
    this.map.getLayers().forEach(function (Floorlayer) {
      if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + _addfloorid) {
        arr_layer[arr_layer.length] = Floorlayer;
      }
    });

    this.select = new Select({
      multi: true,
      style: fillcolorStyle
    });
    this.map.addInteraction(this.select);

    var _select = this.select;
    var _map = this.map;
    var _imageExtent = this.imageExtent;
    var _selectedFeatures = [];

    this.selectedFeatures = this.select.getFeatures();
    
    this.map.on('pointermove', evt => {
      if (!evt.dragging) {
        var pixel = this.map.getEventPixel(evt.originalEvent);
        var hit = this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            return true;
        });
        if (hit) {
          var circlehit = false;
          var features =  _select.getFeatures();
          features.forEach(function(feature) {
            var coords = feature.getGeometry().getCoordinates();
            for (var j = 0; j < coords.length; j++) {
              var coord = coords[j];
                for (var k = 0; k < coord.length; k++) {
                
                  var p0 = evt.pixel;
                  var p1 = ref.map.getPixelFromCoordinate(coord[k]);
                  var dist = ref.pointsDist(p0, p1);
                  if (dist <= 8) {
                    circlehit = true;
                  }
                }
  
              
            }
          });
          if(circlehit) {
            this.map.getTargetElement().style.cursor = 'crosshair';
          }else {
            this.map.getTargetElement().style.cursor = '';
          }
          
        } else {
          this.map.getTargetElement().style.cursor = '';
        }
        //this.map.getTargetElement().style.cursor = this.map.hasFeatureAtPixel(this.map.getEventPixel(evt.originalEvent)) ? 'crosshair' : '';
      }
    });
    var ref =this;
    this.modify = new Modify({
      features: ref.selectedFeatures,
      style: fillcolorStyle,
      deleteCondition: function(e){
        if(shiftKeyOnly(e) && singleClick(e)){
          var features = ref.selectedFeatures;
          features.forEach(function(feature) {
            var coords = feature.getGeometry().getCoordinates();
            for (var j = 0; j < coords.length; j++) {
              var coord = coords[j];
                for (var k = 0; k < coord.length; k++) {
                
                  var p0 = e.pixel;
                  var p1 = ref.map.getPixelFromCoordinate(coord[k]);
                  var dist = ref.pointsDist(p0, p1);
                  if (dist <= 8) {
                    coord.splice(k, 1);
                    ref.updateGeometry(feature, coord);
                    if (IsDevice_In_RoomDrawn(ref.selectedFeatures, ref, ref.addfloorimageheight,1) == true)
                    {
                      localStorage.setItem("FloorId",feature.values_.FloorId);
                      localStorage.setItem("DataId", feature.values_.DataId);
                      localStorage.setItem("DeviceName",NewDeviceTypeDesc.Room);
                      localStorage.setItem("MultiDataId", feature.values_.MultiDataId);
                      localStorage.setItem("MultiDeviceId", feature.values_.MultiDeviceId);
                      localStorage.setItem("MultiFilterDeviceTypeId", feature.values_.MultiFilterDeviceTypeId);
                      localStorage.setItem("UnitId", feature.values_.UnitId);
                      localStorage.setItem("IsDevice", "0");
                      localStorage.setItem("DeviceX", "0");
                      localStorage.setItem("DeviceY", "0");       
                      localStorage.setItem("RoomName", feature.values_.UnitName);   
                      
                    }
                    else
                    {
                      localStorage.setItem("UnitId", "0");
                      localStorage.setItem("DataId", "0");
                    }
                    return;
                  }
                }
              
              
            }
          });
        }else{
          return;
        }
        
       
      },
      
    });
    var _modify = this.modify;

    this.map.getInteractions().forEach((interaction) => {
      if (interaction instanceof Translate) {
        this.map.removeInteraction(interaction);
      }
      if (interaction instanceof Select) {
        interaction.getFeatures().clear()
      }
    });

    _select.on('select', function (e) {      
      if (e.selected) {
        if (_this.select.getFeatures().getLength() == 1) {
          if (e.selected[0] == undefined) {
            getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 1);
          }
          else {
            getSelected(e.selected[0], _this, arr_layer, 1);
          }
        }
        else {
          _this.select.getFeatures().remove(_this.select.getFeatures().getArray()[_this.select.getFeatures().getLength() - 1]);
          getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 1);
        }
      }
    });

    var _addfloorimageheight = this.addfloorimageheight;
    var _imageExtent = this.imageExtent;
    var _sel_feature = null;
    var _sel_polygon = null;
    var _objMapviewFloorComponent = this;

    var _this = this;
    this.modify.on('modifyend', function (e) {
      _sel_feature = e.features;
      if (IsCheckRoomDrawn(_sel_feature.getArray()[0], _this, 1) == true && IsDevice_In_RoomDrawn(_sel_feature, _this, _addfloorimageheight, 1) == true) {
        for (var indx = 0; indx < e.features.getArray().length; indx++) {
          var vertices = e.features.getArray()[indx].getGeometry().flatCoordinates.length;
          if (vertices != 2) {
            _sel_polygon = e.features.getArray()[indx];
            Checkpolygon_Intersect(_objMapviewFloorComponent.map, _objMapviewFloorComponent.dialog, _sel_feature, _sel_polygon, _addfloorid, _addfloorimageheight);
          }
        }
      }
      else{
        ClearStorageSpaceData();
      }
    }, this.selectedFeatures);
    this.map.getInteractions().extend([this.select, this.modify]);
  }


  Rotate_Scale_Points(isScale) {    
    if (!SessionCheck(this.router)) {
      return;
    }
    document.getElementById('divEditSpaceMenu').style.display = "none";
    this.checkIsEdit = true;
    this.checkIsSpace = false;

    localStorage.setItem("CreateNew", "3");
    var arr_Layers = this.map.getLayers();
    this.imageExtent = arr_Layers.array_[0].getSource().getImageExtent();
    document.getElementById('divEditSpaceMenu').style.display = "none";
 

    this.DisableButton("container_EditSpace");

    this.map.getInteractions().forEach((interaction) => {
      if (interaction instanceof Translate) {
        interaction.getFeatures().clear()
      }
      if (interaction instanceof Select) {
        interaction.getFeatures().clear()
      }
    });

    if (!SessionCheck(this.router)) {
      return;
    }
   
    this.checkdrawroomflag = 1;
    this.drawroomselect = 1;
    this.tempVectorSource.clear();

    var fillcolorStyle = fillcolor_styleSelect();

    var _map = this.map;
    var arr_layer = [];
    var _addfloorid = this.addfloorid;
    this.map.getLayers().forEach(function (Floorlayer) {
      if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + _addfloorid) {
        arr_layer[arr_layer.length] = Floorlayer;
      }
    });
    const pstyle = new Style({
      geometry: function (feature) {
        const modifyGeometry = feature.get('modifyGeometry');
        return modifyGeometry ? modifyGeometry.geometry : feature.getGeometry();
      },
      fill: new Fill({
        color: 'rgba(122, 199, 234,0.35)',
      }),
      stroke: new Stroke({
        color: 'rgba(122, 199, 234,1)',
        width: 4
      }),
      image: new CircleStyle({
        radius: 5,
        stroke: new Stroke({
          color: 'rgba(122, 199, 234,1)',
          width: 4
        }),
        fill: new Fill({
          color: '#ffffff',
        }),
      }),
    });
    this.select = new Select({
      multi: true,
      style: function (feature) {
        const styles = [pstyle];
        const modifyGeometry = feature.get('modifyGeometry');
        const geometry = modifyGeometry
          ? modifyGeometry.geometry
          : feature.getGeometry();
        const result = calculateCenter(geometry);
        const center = result.center;
        if (center) {
          styles.push(
            new Style({
              geometry: new Point(center),
              image: new CircleStyle({
                radius: 1,
                fill: new Fill({
                  color: 'rgba(247, 53, 53, 0.1)',
                }),
              }),
            })
          );
          const coordinates = result.coordinates;
          if (coordinates) {
            const minRadius = result.minRadius;
            const sqDistances = result.sqDistances;
            const rsq = minRadius * minRadius;
            const points = coordinates.filter(function (coordinate, index) {
              return sqDistances[index] > rsq;
            });
            styles.push(
              new Style({
                geometry: new MultiPoint(points),
                image: new CircleStyle({
                  radius: 5,
                  stroke: new Stroke({
                    color: 'rgba(122, 199, 234,1)',
                    width: 4
                  }),
                  fill: new Fill({
                    color: '#ffffff',
                  }),
                }),
              })
            );
          }
        }
        return styles;
      },
    });
  
    var _select = this.select;
    var _map = this.map;
    var _imageExtent = this.imageExtent;
    var _selectedFeatures = [];

    this.selectedFeatures = this.select.getFeatures();
  
    this.map.on('pointermove', evt => {
      if (!evt.dragging) {
        var pixel = this.map.getEventPixel(evt.originalEvent);
        var hit = this.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            return true;
        });
        if (hit) {
          var circlehit = false;
          var features =  _select.getFeatures();
          features.forEach(function(feature) {
            var coords = feature.getGeometry().getCoordinates();
            for (var j = 0; j < coords.length; j++) {
              var coord = coords[j];
                for (var k = 0; k < coord.length; k++) {
                
                  var p0 = evt.pixel;
                  var p1 = ref.map.getPixelFromCoordinate(coord[k]);
                  var dist = ref.pointsDist(p0, p1);
                  if (dist <= 8) {
                    circlehit = true;
                  }
                }
  
              
            }
          });
          if(circlehit) {
            this.map.getTargetElement().style.cursor = 'crosshair';
          }else {
            this.map.getTargetElement().style.cursor = '';
          }
          
        } else {
          this.map.getTargetElement().style.cursor = '';
        }
        //this.map.getTargetElement().style.cursor = this.map.hasFeatureAtPixel(this.map.getEventPixel(evt.originalEvent)) ? 'crosshair' : '';
      }
    });


    this.map.getInteractions().forEach((interaction) => {
      if (interaction instanceof Translate) {
        this.map.removeInteraction(interaction);
      }
        interaction.getFeatures().clear()      
    });

    _select.on('select', function (e) {      
      if (e.selected) {
        if (_this.select.getFeatures().getLength() == 1) {
          if (e.selected[0] == undefined) {
            getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 1);
          }
          else {
            getSelected(e.selected[0], _this, arr_layer, 1);
          }
        }
        else {
          _this.select.getFeatures().remove(_this.select.getFeatures().getArray()[_this.select.getFeatures().getLength() - 1]);
          getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 1);
        }
      }
    });

    var _addfloorimageheight = this.addfloorimageheight;
    var _imageExtent = this.imageExtent;
    var _sel_feature = null;
    var _sel_polygon = null;
    var _objMapviewFloorComponent = this;



    const defaultStyle = new Modify({features: this.selectedFeatures})
    .getOverlay()
    .getStyleFunction();

  var ref =this;
  this.modify = new Modify({
    features: ref.selectedFeatures,
    condition: function (event) {
      return primaryAction(event) && !platformModifierKeyOnly(event);
    },
    deleteCondition: function(e){
      if(shiftKeyOnly(e) && singleClick(e)){
        var features = ref.selectedFeatures;
        features.forEach(function(feature) {
          var coords = feature.getGeometry().getCoordinates();
          for (var j = 0; j < coords.length; j++) {
            var coord = coords[j];
              for (var k = 0; k < coord.length; k++) {
              
                var p0 = e.pixel;
                var p1 = ref.map.getPixelFromCoordinate(coord[k]);
                var dist = ref.pointsDist(p0, p1);
                if (dist <= 8) {
                  coord.splice(k, 1);
                  ref.updateGeometry(feature, coord);
                  return;
                }
              }

            
          }
        });
      }else{
        return;
      }
      
     
    },
    insertVertexCondition: never,
    style: function (feature) {
     //feature.get('features').forEach(function (modifyFeature) {
      var features = ref.selectedFeatures;
      features.forEach(function (modifyFeature) {
        const modifyGeometry = modifyFeature.get('modifyGeometry');
        
        if (modifyGeometry) {
          const point = feature.getGeometry().getCoordinates();
          let modifyPoint = modifyGeometry.point;
          
          if (!modifyPoint) {
            // save the initial geometry and vertex position
            modifyPoint = point;
            modifyGeometry.point = modifyPoint;
            modifyGeometry.geometry0 = modifyGeometry.geometry;
            // get anchor and minimum radius of vertices to be used
            const result = calculateCenter(modifyGeometry.geometry0);
            modifyGeometry.center = result.center;
            modifyGeometry.minRadius = result.minRadius;
          }
  
          const center = modifyGeometry.center;
          const minRadius = modifyGeometry.minRadius;
          let dx, dy;
          dx = modifyPoint[0] - center[0];
          dy = modifyPoint[1] - center[1];
          const initialRadius = Math.sqrt(dx * dx + dy * dy);
          if (initialRadius > minRadius) {
            const initialAngle = Math.atan2(dy, dx);
            dx = point[0] - center[0];
            dy = point[1] - center[1];
            const currentRadius = Math.sqrt(dx * dx + dy * dy);
            if (currentRadius > 0) {
              const currentAngle = Math.atan2(dy, dx);
              const geometry = modifyGeometry.geometry0.clone();
              if(isScale == 1){
                geometry.scale(currentRadius / initialRadius, undefined, center);
              }else{
                geometry.rotate(currentAngle - initialAngle, center); 
              }
             
              
              modifyGeometry.geometry = geometry;
            }
          }
        }
      });
      return style(feature);
    },
  });
  
  
  
  
  this.modify.on('modifystart', function (event) {    
    event.features.forEach(function (feature) {      
      feature.set(
        'modifyGeometry',
        {geometry: feature.getGeometry().clone()},
        true
      );
    });
  });
  
  var _this = this;
  var _sel_feature = null;

    this.modify.on('modifyend', function (e) {      
      _sel_feature = e.features;
      e.features.forEach(function (feature) {
        const modifyGeometry = feature.get('modifyGeometry');
        if (modifyGeometry) {
          feature.setGeometry(modifyGeometry.geometry);
          feature.unset('modifyGeometry', true);
        }
      });
      if(IsDevice_In_RoomDrawn(_sel_feature, _this, _addfloorimageheight, 0) == false)
      {
        _this.rotateIsInside = 0;
      }
      if (IsCheckRoomDrawn(_sel_feature.getArray()[0], _this, 1) == true ) {
        _sel_feature = e.features;
        for (var indx = 0; indx < e.features.getArray().length; indx++) {
          var vertices = e.features.getArray()[indx].getGeometry().flatCoordinates.length;
          if (vertices != 2) {
            _sel_polygon = e.features.getArray()[indx];
            Checkpolygon_Intersect(_objMapviewFloorComponent.map, _objMapviewFloorComponent.dialog, _sel_feature, _sel_polygon, _addfloorid, _addfloorimageheight);
          }
        }
      }
      else{
        ClearStorageSpaceData();
      }
    });
  
  this.map.getInteractions().extend([this.select, this.modify]);  
}

pointsDist(p0, p1) {
  var dx = p0[0] - p1[0];
  var dy = p0[1] - p1[1];        
  return (Math.sqrt(dx*dx + dy*dy));
}

updateGeometry(feature, coord) {
  feature.getGeometry().setCoordinates([coord]);
}


//Move Option will help to move the devices from one space to another space

  selectedFeatures;
  select_move(duplicate_feature) {
    this.IsDuplicateAdded = 0;
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Move;
    var elem = document.getElementById('container_DeviceList');
    if ((elem.classList.contains('enablebtn')) || (duplicate_feature != undefined && duplicate_feature.length > 0 && this._translateend == 0) || duplicate_feature == -1) {
      this.checkIsEdit = true;
      this.checkIsSpace = false;
      localStorage.setItem("CreateNew", "2");
      var arr_Layers = this.map.getLayers();
      this.imageExtent = arr_Layers.array_[0].getSource().getImageExtent();
      document.getElementById('divEditSpaceMenu').style.display = "none";

      var saveBtn = document.getElementById("btnsaveclickmapview");
      if (saveBtn.innerHTML == "Done") saveBtn.innerHTML = "Save";

      this.DisableButton("container_SelectMove");

      this.tempVectorSource.clear();
      this.map.removeLayer(this.tempVectorLayer);

      this.map.getInteractions().forEach((interaction) => {
        if (interaction instanceof Translate) {
          interaction.getFeatures().clear()
        }
        if (interaction instanceof Select) {
          interaction.getFeatures().clear()
        }
        if (interaction instanceof Draw) {
          this.map.removeInteraction(interaction);
        }
        if (interaction instanceof Modify) {
          this.map.removeInteraction(interaction);
        }
      });

      if (!SessionCheck(this.router)) {
        return;
      }

      this.checkdrawroomflag = 1;
      this.drawroomselect = 1;
      this.tempVectorSource.clear();

      var fillcolorStyle = fillcolor_styleSelect();


      if (duplicate_feature != undefined && duplicate_feature !=-1 && duplicate_feature.length > 0) {
        this.select = new Select({
          features: duplicate_feature,
          style: fillcolorStyle
        });
      }
      else {
        this.select = new Select({
          style: fillcolorStyle
        });
      }

      this.map.addInteraction(this.select);

     var _select = this.select;
      var _map = this.map;
      var arr_layer = [];
      var _addfloorid = this.addfloorid;
      this.map.getLayers().forEach(function (Floorlayer) {
        if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + _addfloorid) {
          arr_layer[arr_layer.length] = Floorlayer;
        }
      });

      this.selectedFeatures = this.select.getFeatures();
      this.translate = new Translate({
        features: this.selectedFeatures,
        style: fillcolorStyle
      }); 

      var _this = this;
      _this.select.on('select', function (e) {
        if (e.selected) {
          if (_this.select.getFeatures().getLength() == 1) {
            if (e.selected[0] == undefined) {
              getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 0);
            }
            else {
              getSelected(e.selected[0], _this, arr_layer, 0);
            }
          }
          else {
            _this.select.getFeatures().remove(_this.select.getFeatures().getArray()[_this.select.getFeatures().getLength() - 1]);
            if (_this.select.getFeatures().getArray()[0]!=undefined)
              getSelected(_this.select.getFeatures().getArray()[0], _this, arr_layer, 0);
          }
        }
      });

      var _addfloorimageheight = this.addfloorimageheight;
      var _imageExtent = this.imageExtent;
      var _sel_feature = null;
      var _sel_polygon = null;
      var _objMapviewFloorComponent = this;

      var _this = this;
       this.translate.on('translateend', function (e) {
        _this._translateend = 1;
        if (e.features.getArray().length == 1) {
          _sel_feature = e.features.getArray()[0];          
          get_selectedfeature(_objMapviewFloorComponent.map, _objMapviewFloorComponent.dialog, _sel_feature, _addfloorid, _addfloorimageheight);          
        }
        else {
          _sel_feature = e.features;
          if (IsCheckRoomDrawn(_sel_feature.getArray()[0], _this, 1) == true) {
            for (var indx = 0; indx < e.features.getArray().length; indx++) {
              var vertices = e.features.getArray()[indx].getGeometry().flatCoordinates.length;
              if (vertices != 2) {
                _sel_polygon = e.features.getArray()[indx];
                Checkpolygon_Intersect(_objMapviewFloorComponent.map, _objMapviewFloorComponent.dialog, _sel_feature, _sel_polygon, _addfloorid, _addfloorimageheight);
              }
            }
          }
          else{
            ClearStorageSpaceData();
          }
        }
      }, this.selectedFeatures);


      this.map.getInteractions().extend([this.select, this.translate]);
     
     
    }
    else if (this._translateend == 1) {
      this._translateend = 0;
      var ConfirmMessageData = {
        ConfirmMessage: "Do you want to save the modification?"
      }
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == "Yes") {
          // dialogRef.close('Cancel');
          // return;          
          localStorage.setItem("IsModifyYes","1");
          this.onSaveCampusRoom();
        }
        else {
          this.ResetButton();
          this.ClearDataRefresh();
        }
      });
    }
    else {
      this.ResetButton();
      this.ClearDataRefresh();
    }
  }

  Unitinfo = [];
  Unitnameforfloor;
  addHRexflag: addHRexflag[];
  getdeviceforadd;
  MaxRexvalue;
  deviceTypeName;

  strLocationName: string;
  strRoomName: string;
  strDeviceId: number;
  strEmitterId: number;

  strMacId: string;
  strLFId: number;
  strLocation: string;
  strDCMacId: string;


  selectedUnit = 0;

  public deviceaddForm: FormGroup;

  strDeviceDualId: number;

  strRexDeviceId: number;
  checkDCTag = false;
  checkDCLotiering = false;
  checkDCUnauthorizedEgress = false;

  disableDCLotiering = true;
  disableDCUnauthorizedEgress = true;

  checkPCRemovalDetection = false;
  checkPCButtonPress = false;
  checkPullCord = false;
  checkPCMobilityMode = false;

  checkDCT_Tag1 = false;
  checkDCT_Tag2 = false;
  checkDCT_Tag3 = false;

  checkDCT_TagEnable1 = 0;
  checkDCT_TagEnable2 = 0;
  checkDCT_TagEnable3 = 0;

  checkDCT_Ambient1 = false;
  checkDCT_Ambient2 = false;

  selectedAlertState1 = 0;
  selectedAlertState2 = 0;
  selectedAlertState3 = 0;

  disableAlertmessage1 = 0;

  overTempflag = 0;

  probeoverTempflag = 0;
  humidityoverTempflag = 0;

  checkDCT_Probe1 = false;
  checkDCT_Probe2 = false;

  checkDCT_Humidity1 = false;
  checkDCT_Humidity2 = false;

  HRexId;
  GatewayId;
  HRexMacId;
  GatewayMacId;
  getHRexMacId;
  GatewayDetails;
  getgatewaymacid;
  getRexvalue;
  getRexMaxvalue;
  selectdefaultMode = '0';
  selectdefaultDCTMode = '0';
  addnewDeviceflag = 0;

  //Draw feature for Devices
  tempVectorSource = new VectorSource();
  tempVectorLayer = new OlVectorLayer({
    source: this.tempVectorSource
  });

  tempgridSource = new VectorSource();
  tempGridLayer = new OlVectorLayer({
    source: this.tempgridSource
  });
  public showCampus: boolean = true;
  public showFloor: boolean = false;
  public showEmitter: boolean = false;
  public showLF: boolean = false;
  public showMac: boolean = false;
  public showHrex: boolean = false;
  public showpullcord: boolean = false;
  public showDC: boolean = false;
  public showMonitor: boolean = false;
  public showVW: boolean = false;
  public showGateway: boolean = false;
  public isSaveFloorDevice: boolean = false;
  public showDCT: boolean = false;
  public showUM: boolean = false
  //Add devices will open the window to select the device to place in the space.
  
  addNewDevice(CampusId, campusName) {
    var elem = document.getElementById('container_DeviceList');
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Add_Device;
    if (elem.classList.contains('enablebtn')) {
      document.getElementById('container_AddDevice').style.pointerEvents = "none";
      localStorage.setItem("CreateNew", "1");
      this.checkIsSpace = false;
      this.checkIsEdit = false;
      var saveBtn = document.getElementById("btnsaveclickmapview");
      saveBtn.innerHTML = "Done";
      this.DisableButton("container_AddDevice");
      document.getElementById('container_AddDevice').style.pointerEvents = "none";
      try {
        let deviceaddelement = document.getElementById('divAddDevice');
        deviceaddelement.className = 'disable';
        let devicelistelement = document.getElementById('divDeviceheader');
        devicelistelement.className = 'disable';
        if (!SessionCheck(this.router)) {
          return;
        }

        this.getHrexflag();
        this.getMaxRexdevicedetail();
        var _dialog = this.dialog;
        let mapsyncinfo : MapSyncProcess = 
        {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey")
        };
        this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
          .subscribe((MapSyncinfo: any[]) => {
            this.MapSyncProcess = MapSyncinfo;
            if (this.MapSyncProcess == 1) {
              generateAlertMessage(_dialog, appsettings.MapSyncMsg);
              let deviceaddelement = document.getElementById('divAddDevice');
              deviceaddelement.className = 'enable';
              let devicelistelement = document.getElementById('divDeviceheader');
              devicelistelement.className = 'enable';
              document.getElementById('container_AddDevice').style.pointerEvents = "";
              this.ResetButton();
              return false;
            }
            else {
              if (this.addnewDeviceflag == 0) {
                let voiceLicense = localStorage.getItem("voice_license");
                let floordetails =
                {
                  siteId: this.SiteId,
                  authKey: localStorage.getItem("Authkey"),
                  floorId: this.addfloorid,
                  isIndoor: 1,
                  isNeedIntercom: parseInt(voiceLicense),
                  isSubZone : 0
                }
                this.apiService.getUnitDetails(floordetails).pipe(takeUntil(this._onDestroy))
                  .subscribe((Unitsinfo: any[]) => {
                    if (Unitsinfo != null && Unitsinfo != undefined) {
                      this.Unitinfo = Unitsinfo["apiReturn"];
                      this.addnewDeviceflag = 1;
                      this.addNewdevicedetails(Unitsinfo["apiReturn"], CampusId, campusName);
                    }
                  });
              }
            }
          });

      }
      catch (err) {
        document.getElementById('container_AddDevice').style.pointerEvents = "";
        throw new Error('device.component.ts' + ' - addNewDevice() - ' + err.message);
      }
    }
    else {
      this.ResetButton();
    }
    
    this.ClearInteraction();
  }

  addNewdevicedetails(UnitInfo, CampusId, CampusName) {
    try {
      var _ShareddialogcloseDetails = {
        "SharedreturncloseVal": 1
      };
      this.alertSharedService.changeclosedialog(_ShareddialogcloseDetails);
      if (this.addfloorid != 0) {
        if (UnitInfo.length == 0) {
          this.addnewDeviceflag = 0;
          generateAlertMessage(this.dialog, 'Please add the space in the zone.');
          document.getElementById('container_AddDevice').style.pointerEvents = "";
          this.ResetButton();
          return;
        }
        else {
          this.Unitnameforfloor = UnitInfo[0].UnitName;
        }

      }
      else {
        this.Unitnameforfloor = "";
      }

      var HRexFlag = 0;
      var GatewayFlag = 0;
      if (this.addfloorid != 0) {
        if (this.addHRexflag.toString() == "H-rex found") {
          HRexFlag = 1;
          GatewayFlag = 0;
        }

        else if (this.addHRexflag.toString() == "Gateway found") {
          HRexFlag = 0;
          GatewayFlag = 1;
        }

        else if (this.addHRexflag.toString() == "both are found") {
          HRexFlag = 1;
          GatewayFlag = 1;
        }
        else if (this.addHRexflag.toString() == "false") {
          HRexFlag = 0;
          GatewayFlag = 0
        }

      }
      //alert(HRexFlag);                              
      let CampusDetail = {
        CampusId: CampusId, CampusName: CampusName, MapDetails: this.map, VectorDetails: this.vector, BuildingId: this.addbuildingid, UnitInfo: UnitInfo, UnitName: this.Unitnameforfloor, FloorId: this.addfloorid,
        ImageHeight: this.addfloorimageheight, ImageWidth: this.ImageWidth, HRexvalue: HRexFlag, Gatewayvalue: GatewayFlag, MaxRexValue: this.MaxRexvalue, SelectedFeature: this.selectedFeature
      }
      var devicedataforadd = [];
      devicedataforadd.push(this.getdeviceforadd, CampusDetail)

      if (this.adddevicedialogopen == 0) {
        let dialogRef = this.dialog.open(AddDeviceComponent, {
          disableClose: true,
          width: '55em',
          height: '550px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: CampusDetail
        });
        this.adddevicedialogopen = 1;
        dialogRef.afterClosed().subscribe(result => {
          document.getElementById('container_AddDevice').style.pointerEvents = "";
          this.addnewDeviceflag = 0;
          this.adddevicedialogopen = 0;
          if (result != "Cancel") {
            this.Selected_ImageDeviceTypename = result.selectImageDeviceTypeName;
            this.Selected_DeviceTypename = result.selectDeviceType;
            this.deviceTypeName = result.selectDeviceType;
            //this.ClearInteraction();
            this.closeDrawFeature();
            this.tempVectorSource.clear();
            this.DrawDeviceFeature(this.Selected_ImageDeviceTypename);
          }
          else {
            this.ResetButton();
            this.ClearInteraction();
          }

          let devicelistelement = document.getElementById('divDeviceheader');
          devicelistelement.className = 'enable';
          let deviceaddelement = document.getElementById('divAddDevice');
          deviceaddelement.className = 'enable';

          this.EnableButton();
        })
      }
    }
    catch (err) {
      throw new Error('device.component.ts' + ' - addNewdevicedetails() - ' + err.message);
    }

  }

  public onSaveCampusRoom = () => {
    this.deviceTypeName = this.Selected_DeviceTypename;
    this.CheckIsAdd = true;
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close('Cancel');
        return;
      }
      (this.document.activeElement as HTMLTextAreaElement).blur();
      if (this.CheckIsAdd == true && this.checkIsEdit == true && this.Edit_pointsbool) {
        let verticesinfo = null;
        var imageheight = this.addfloorimageheight;
        this.Edit_pointsbool = false;
        var DataId = localStorage.getItem("DataId");
        var FloorId = localStorage.getItem("FloorId");
        this.deviceTypeName = localStorage.getItem("DeviceName");
        var _this = this;
        verticesinfo = localStorage.getItem("Polypoints");
        if (verticesinfo == null || verticesinfo == undefined) {
          var keepGoing = true;
          this.map.getLayers().forEach(function (selRoomlayer) {
            
            if (keepGoing) {
              if (selRoomlayer.get('FloorId') != undefined && selRoomlayer.get('FloorId') === "Floor_" + FloorId) {
                var arrFeature = selRoomlayer.getSource().getFeatures();
                if (arrFeature) {
                  // Go through this array and get coordinates of their geometry.           
                  arrFeature.forEach(function (selRoomfeature) {
                    var SelectedRoomDataId = selRoomfeature.getProperties().MultiDataId.toString();
                    if (SelectedRoomDataId.split(',').indexOf(parseInt(DataId).toString()) != -1 && selRoomfeature.getGeometry().flatCoordinates.length != 2 && _this.rotateIsInside == 1) {
                      vertices = selRoomfeature.getGeometry().getCoordinates();
                      keepGoing = false;
                      return false;
                    }
                    else{
                      return true;
                    }
                  });
                }
              }
            }
          });

          if (vertices == undefined) {
            var _DeviceTypeNew = localStorage.getItem("DeviceName");
            if(_this.rotateIsInside == 0)
            {
              generateAlertMessage(_this.dialog, "Please change the room drawn as it able to have all its devices in it");
            }
            else if (_DeviceTypeNew != undefined) {
              if (_DeviceTypeNew !=NewDeviceTypeDesc.Room)
              {
                _DeviceTypeNew = getDeviceTypeNew(_DeviceTypeNew);
                generateAlertMessage(this.dialog, "Please place a " + _DeviceTypeNew + " in the room drawn");
              }
            }
          }
          else {
            verticesinfo = "";
            if (vertices.length > 0) {
              for (var j = 0; j < vertices[0].length; j++) {
                polypoints = imageheight - parseFloat(vertices[0][j][1]);
                vertices[0][j][0] = Math.floor(vertices[0][j][0]);
                vertices[0][j][1] = Math.floor(polypoints);
                if (verticesinfo.length == 0) {
                  verticesinfo += vertices[0][j][0] + "," + vertices[0][j][1];
                }
                else {
                  verticesinfo = verticesinfo + " " + vertices[0][j][0] + "," + vertices[0][j][1];
                }
              }
            }
          }
          if(verticesinfo != null)
          localStorage.setItem("Polypoints", verticesinfo);
          localStorage.setItem("OldUnitId", "0");
        }
        var _UnitId = localStorage.getItem("UnitId");
        if (_UnitId != null && _UnitId != "0" && verticesinfo != null)
        {
            this.onupdateFloorRoom()
        }
        else{
          this.Edit_pointsbool = true;
          this.EditSaveExists();
        }
      }
      else {
        try {
          if (this.checkdrawroomflag == 0 && this.addfloorid == 0) {
            generateAlertMessage(this.dialog, "Please draw the Building");
            return false;
          }
          else if (this.selectedBuilding == 0) {
            generateAlertMessage(this.dialog, "Please select the Building");
            return false;
          }
          // Get the array of features
          if (this.CheckIsAdd != true || this.checkIsSpace == true) {
            if (this.vector.getSource() == null) {
              generateAlertMessage(this.dialog, "Please draw the room");
              return false;
            }
            var features = this.vector.getSource().getFeatures();
            if (features.length == 0 && this.addfloorid == 0) {
              generateAlertMessage(this.dialog, "Please draw the Building");
              return false;
            }
            else if (features.length == 0 && this.addfloorid != 0) {
              if (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW || this.deviceTypeName == DeviceTypeDesc.UM) {
                generateAlertMessage(this.dialog, "Please draw the room");
                return false;
              }
              else if (this.deviceTypeName == undefined) {
                generateAlertMessage(this.dialog, "Please draw the room");
                return false;
              }
            }
          }
        }
        catch
        {
          if (this.deviceTypeName == DeviceTypeDesc.Emitter || this.deviceTypeName == DeviceTypeDesc.Monitor || this.deviceTypeName == DeviceTypeDesc.VW || this.deviceTypeName == DeviceTypeDesc.UM) {
            generateAlertMessage(this.dialog, "Please draw the room");
            return false;
          }
        }
        //this.isSaveFloorDevice = false;

        var vertices;
        let verticesinfo = "";
        var polypoints;
        var featurespoly;
        var imageheight = this.addfloorimageheight;
        // Get the array of features
        if (this.CheckIsAdd != true || this.checkIsSpace == true) {
          if (features != undefined) {
            var features = this.vector.getSource().getFeatures();
            // Go through this array and get coordinates of their geometry.
            features.forEach(function (feature) {
              featurespoly = feature.getGeometry().getCoordinates();
              featurespoly[0].pop();
              for (var j = 0; j < featurespoly[0].length; j++) {
                polypoints = imageheight - parseFloat(featurespoly[0][j][1]);
                featurespoly[0][j][0] = Math.floor(featurespoly[0][j][0]);
                featurespoly[0][j][1] = Math.floor(polypoints);
                if (verticesinfo.length == 0) {
                  verticesinfo += featurespoly[0][j][0] + "," + featurespoly[0][j][1];
                }
                else {
                  verticesinfo = verticesinfo + " " + featurespoly[0][j][0] + "," + featurespoly[0][j][1];
                }
              }
            });
          }
        }
        else if (localStorage.getItem("CreateNew") == "1") {
          var DataId = localStorage.getItem("DataId");
          var FloorId = localStorage.getItem("FloorId");
          var keepGoing = true;
          this.map.getLayers().forEach(function (selRoomlayer) {
            
            if (keepGoing) {
              if (selRoomlayer.get('FloorId') != undefined && selRoomlayer.get('FloorId') === FloorId) {
                var arrFeature = selRoomlayer.getSource().getFeatures();
                if (arrFeature) {
                  // Go through this array and get coordinates of their geometry.           
                  arrFeature.forEach(function (selRoomfeature) {
                    var SelectedRoomDataId = selRoomfeature.getProperties().DataId;
                    if (parseInt(SelectedRoomDataId) == parseInt(DataId)) {
                      vertices = selRoomfeature.getGeometry().getCoordinates();
                      keepGoing = false;
                      return false;
                    }
                    else{
                      return true;
                    }
                  });
                }
              }
            }
          });

          if (vertices == undefined) {
            var _DeviceTypeNew = localStorage.getItem("DeviceTypeName");
            if (_DeviceTypeNew != undefined) {
              if (_DeviceTypeNew !=NewDeviceTypeDesc.Room)
              {
                _DeviceTypeNew = getDeviceTypeNew(_DeviceTypeNew);
                generateAlertMessage(this.dialog, "Please place a " + _DeviceTypeNew + " in the room drawn");
              }
            }
          }
          else {
            if (vertices.length > 0) {
              for (var j = 0; j < vertices[0].length; j++) {
                polypoints = imageheight - parseFloat(vertices[0][j][1]);
                vertices[0][j][0] = Math.floor(vertices[0][j][0]);
                vertices[0][j][1] = Math.floor(polypoints);
                if (verticesinfo.length == 0) {
                  verticesinfo += vertices[0][j][0] + "," + vertices[0][j][1];
                }
                else {
                  verticesinfo = verticesinfo + " " + vertices[0][j][0] + "," + vertices[0][j][1];
                }
              }
            }
          }
        }

       

        var _DataId = localStorage.getItem("DataId");
        var _UnitId = localStorage.getItem("UnitId");
        var _RoomName = localStorage.getItem("RoomName");

        if (this.checkIsSpace == true) {
          this.onSaveFloorSpace(verticesinfo);
        }
        else if (_DataId != null && _UnitId != null && _UnitId != "0" && _RoomName != null) {
          this.onsaveFloorRoom(verticesinfo, this.deviceTypeName, _DataId, _UnitId, _RoomName);
        }
        else
        { //no action
          generateAlertMessage(this.dialog, "All changes already saved. It is safe to exit editing mode.");
        }

      }

    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - onSaveCampusRoom() - ' + err.message);
    }

  }

  onSaveFloorSpace(polypoints) {
    this.add_space(polypoints);
  }
  

  onsaveFloorRoom(polypoints, devicename, _DataId, _UnitId, _RoomName) {
    try {
 
      var polyline = new Array();
      polyline = polypoints.split(' ');
      var vertices;

     

      this.strDeviceId = 0;
      this.selectedUnit = 5;
      this.showHrex = true;
      this.showGateway = true;
      this.strRoomName = "testdevicenewtech";

      // Get the array of features
      var features = this.tempVectorLayer.getSource().getFeatures();
      // Go through this array and get coordinates of their geometry.
      features.forEach(function (feature) {
        vertices = feature.getGeometry().getCoordinates();
      });

      var deviceX = convertToSvgEcllipseXCoordinate(parseFloat(vertices[0]), true);
      var deviceY = convertToSvgEcllipseYCoordinate(parseFloat(vertices[1]), this.addfloorimageheight);
      
      this.adddeviceflag = 1;
      
      this.editDevicedetails(0,this.deviceTypeName,_UnitId,_RoomName,polypoints,deviceX,deviceY,_DataId);       

    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - onsaveFloorRoom() - ' + err.message);
    }

  }   

  onupdateFloorRoom() {
    try {
      var _Polypoints = localStorage.getItem("Polypoints");
      var _UnitId = localStorage.getItem("UnitId");
      var Old_UnitId = localStorage.getItem("OldUnitId");

      var _DeviceX = localStorage.getItem("DeviceX");
      var _DeviceY = localStorage.getItem("DeviceY");
      var _DataId = localStorage.getItem("DataId");
      var _MultiDataId = localStorage.getItem("MultiDataId");
      var _DeviceId = localStorage.getItem("MultiDeviceId");
      var _DeviceType = localStorage.getItem("MultiFilterDeviceTypeId");
      var _IsDevice = localStorage.getItem("IsDevice");
      this.deviceTypeName = localStorage.getItem("DeviceName");
      var devicename = localStorage.getItem("DeviceName");

      var arr_DeviceX = [];
      var arr_DeviceY = [];
      var arr_DataId = [];
      var arr_DeviceId = [];
      var arr_DeviceType = [];
      
      if(_DeviceX != null)
        arr_DeviceX = _DeviceX.toString().split(',');
      if(_DeviceY != null)
        arr_DeviceY = _DeviceY.toString().split(',');
      if(_MultiDataId != null)
       arr_DataId = _MultiDataId.toString().split(',');
      if(_DeviceId != null)
       arr_DeviceId = _DeviceId.toString().split(',');
      if(_DeviceType != null)
        arr_DeviceType = _DeviceType.toString().split(',');

      if (localStorage.getItem("MultiDataId")=='')
      {
          _MultiDataId=_DataId;
          _DeviceType=NewDeviceTypeDesc.Room;
      }

      let adddevicedetails: getPolylineRequest 
      if (_IsDevice == "1") {
        adddevicedetails = {
          siteId: this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          dataId: _DataId,          
          unitId: parseInt(_UnitId),                  
          polypoints: _Polypoints,
          deviceX: arr_DeviceX[0],
          deviceY: arr_DeviceY[0],
          unitIdOld: parseInt(Old_UnitId),
          isOutdoorLocation:0,
        }
      }
      else {
        adddevicedetails = {
          siteId: this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          dataId: _MultiDataId,          
          unitId: parseInt(_UnitId),                    
          polypoints: _Polypoints,
          deviceX: _DeviceX,
          deviceY: _DeviceY,
          unitIdOld: parseInt(Old_UnitId),
          isOutdoorLocation:0,
        }
      }
      
      this.technologyoverlayService.updatePolylineFloor(adddevicedetails).pipe(takeUntil(this._onDestroy))
        .subscribe((apiresponse: TechnologyForCreationResponse[]) => {
          if (apiresponse.toString() == "true") {
            this.EditSaveCall();
          }
          else if (apiresponse.toString() == "false") {
            generateAlertMessage(this.dialog, apiresponse.toString());
            let saveclick = document.getElementById('btnsaveclickmapview');
            saveclick.className = 'clsdeviceaddbutton mat-raised-button';
          }
          else if (apiresponse["condition"] == "Authfalse") {
            this.thisDialogRef.close('close');
            AuthFailedMessage(this.dialog, this.router);
            return;
          }
          else {
            generateAlertMessage(this.dialog, apiresponse.toString());
            let saveclick = document.getElementById('btnsaveclickmapview');
            saveclick.className = 'clsdeviceaddbutton mat-raised-button mat-primary';
          }
        });
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - onupdateFloorRoom() - ' + err.message);
    }
  }

  CheckRoomDrawn() {
    var roomDrwan = false;
    if (this.vector.getSource() != null) {
      if (this.vector.getSource().getFeatures().length == 0) {
        roomDrwan = true;
      }
      else {
        // Get the array of features
        var features = this.vector.getSource().getFeatures();
        var vertices;
        let polyLine = [];

        if (features) {
          // Go through this array and get coordinates of their geometry.
          features.forEach(function (feature) {
            vertices = feature.getGeometry().getCoordinates();
          });
        }

        vertices[0].pop();
        polyLine = vertices[0];

        for (var i = 0; i < polyLine.length; i++) {
          var xi = polyLine[i][0], yi = polyLine[i][1];
          if (xi < 0 || yi < 0 || xi > this.imageExtent[2] || yi > this.imageExtent[3]) {
            roomDrwan = true;
            break;
          }
        }
      }
    }
    return roomDrwan;
  }

  CheckPointInMap() {
    var roomDrwan = false;
    if (this.tempVectorLayer.getSource() != null) {
      if (this.tempVectorLayer.getSource().getFeatures().length == 0) {
        roomDrwan = true;
      }
      else {
        // Get the array of features
        var features = this.tempVectorLayer.getSource().getFeatures();
        var vertices;

        if (features) {
          // Go through this array and get coordinates of their geometry.
          features.forEach(function (feature) {
            vertices = feature.getGeometry().getCoordinates();
          });
        }
        if (vertices.length > 0) {
          if (vertices[0] < 0 || vertices[1] < 0 || vertices[0] > this.imageExtent[2] || vertices[1] > this.imageExtent[3]) {
            roomDrwan = true;
            this.tempVectorLayer.getSource().clear();
          }
        }
        else {
          roomDrwan = true;
        }
      }
    }
    return roomDrwan;
  }

  duplicate() {
    try {
      var _UnitId = localStorage.getItem("UnitId");
      document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Duplicate_Space;
      if (_UnitId != undefined && parseInt(_UnitId) != 0) {
        var saveBtn = document.getElementById("btnsaveclickmapview");
        if (saveBtn.innerHTML == "Done") saveBtn.innerHTML = "Save";
        var elem = document.getElementById('container_DeviceList');
        if (elem.classList.contains('enablebtn')) {
          this.DisableButton("container_Duplicate");
        }

        if (!SessionCheck(this.router)) {
          return;
        }

        var _dialog = this.dialog;
        let mapsyncinfo : MapSyncProcess = 
        {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey")
        };
        this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
          .subscribe((MapSyncinfo: any[]) => {
            this.MapSyncProcess = MapSyncinfo
            if (this.MapSyncProcess == 1) {
              generateAlertMessage(_dialog, appsettings.MapSyncMsg);
              return false;
            }
            else {
              let unitbyid: UnitById = {
                siteId: this.SiteId,
                authKey: localStorage.getItem("Authkey"),
                unitId: parseInt(_UnitId)
              }

              this.technologyoverlayService.getUnitById(unitbyid).pipe(takeUntil(this._onDestroy))
                .subscribe((UnitByIddetails: any[]) => {
                  
                  this.UnitByIddetails = UnitByIddetails["apiReturn"][0];
                  this.duplicateunitopendialog(this.UnitByIddetails)
                });
            }
          });
      }
      else {
        generateAlertMessage(this.dialog, 'Please select the space to duplicate.');
        return;
      }
    }
    catch (err) {
      throw new Error('floorplans.component.ts' + ' - duplicateUnitdetails() - ' + err.message);
    }
  }

  duplicateunitopendialog(UnitById) {
    
    if (this.uniteditdialogopen == 0) {
      let dialogRef = this.dialog.open(DuplicateUnitComponent, {
        disableClose: true,
        width: '75em',
        height: '500px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: UnitById
      });
      this.uniteditdialogopen = 1;
      dialogRef.afterClosed().subscribe(result => {
        if (result == "close") {
          this.uniteditdialogopen = 0;
          
          let floorplanslistelement = document.getElementById('divfloorplandetails');
          if (floorplanslistelement != null)
            floorplanslistelement.className = 'clsenable';
          
        }
        else if (result.hasOwnProperty('NewSpaceId')) {
          this.uniteditdialogopen = 0;
          this.ResetButton();
          this.IsDuplicateAdded = result["NewSpaceId"];
          this.ClearDataRefresh();
          let floorplanslistelement = document.getElementById('divfloorplandetails');
          if (floorplanslistelement != null)
            floorplanslistelement.className = 'clsenable';
        }
      })
    }

    this.EnableButton();
  }

  insert_template() {
    var saveBtn = document.getElementById("btnsaveclickmapview");
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Insert_Template;
    if (saveBtn.innerHTML == "Done") saveBtn.innerHTML = "Save";
    var elem = document.getElementById('container_DeviceList');
    if (elem.classList.contains('enablebtn')) {
      this.DisableButton("container_InsertTemplate");
    }
    let tempdata: getTemplates = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),      
    }
    let template_data = [];
    this.technologyoverlayService.getTemplates(tempdata).pipe(takeUntil(this._onDestroy))
    .subscribe((TempDetails : any[])=>{  
      
        TempDetails.forEach(function(e){   
          if(e.TemplateCategoryId == 2)
          {
            template_data.push(e);
          }
        })  
        if(template_data.length == 0)
        {
          generateAlertMessage(this.dialog, 'No Space Template available.');
          this.EnableButton();
          return;
        }
        else
        {
          if(this.insertTemplatebool == false)
          {
              this.insertTemplatebool = true;
              let dialogRef = this.dialog.open(InsertTemplateComponent, {
                disableClose: true,
                width: '85em',
                height:'760px',
                panelClass: 'myapp-no-padding-dialog',
                autoFocus: false,
                data: this.getfloordata
              });
              dialogRef.afterClosed().subscribe(result => {
                this.insertTemplatebool = false;
              if (result == "Cancel" || result == null || result == "") {
                this.ResetButton();
                this.ClearDataRefresh();
                return;
              }

              if (result != "close") {
                this.ResetButton();
                this.IsDuplicateAdded = result["UnitId"];
                this.ClearDataRefresh();
                let floorplanslistelement = document.getElementById('divfloorplandetails');
                if (floorplanslistelement != null)
                  floorplanslistelement.className = 'clsenable';
              }
            });
          }
        }
  })
  }

  add_space(polypoints) {
    let SpaceData = { FloorData: this.getfloordata, Polypoints: polypoints }
    let dialogRef = this.dialog.open(AddUnitComponent, {
      disableClose: true,
      width: '45em',
      height: '650px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: SpaceData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != "Cancel") {
        this.ResetButton();
        this.ClearDataRefresh();
      }
    });

  }

  btnclkfloormapinfohide() {
    this.ClearStoredData();
    this.router.navigate(['../../floorplans'], { state: this.getfloordata });
  }

  deleteinfo() {
    var elem = document.getElementById('container_DeviceList');
    document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Delete_Space;
    if (elem.classList.contains('enablebtn')) {
      var saveBtn = document.getElementById("btnsaveclickmapview");
      if (saveBtn.innerHTML == "Done") saveBtn.innerHTML = "Save";
      this.DisableButton("container_DeleteSpace");
    }

    var selectedUnitId = parseInt(localStorage.getItem("UnitId"));
    if (selectedUnitId > 0) {
      this.deleteUnit(selectedUnitId);
    }
    else {
      generateAlertMessage(this.dialog, appsettings.DeleteSpace);
      this.EnableButton();
      return;
    }
    this.EnableButton();
  }

  editDevicedetails(DeviceDataid,deviceTypeName,UnitId,UnitName,verticesinfo,deviceX,deviceY,_DataId) {
    try {
      if (!SessionCheck(this.router)) {
        return;
      }
      var deviceinfo;
      var _dialog = this.dialog;
      var Data_Id;
      var Device_Type = deviceTypeName;
      let mapsyncinfo : MapSyncProcess = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey")
      };      
      this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
        .subscribe((MapSyncinfo: any[]) => {
          this.MapSyncProcess = MapSyncinfo
          if (this.MapSyncProcess == 1) {
            generateAlertMessage(_dialog, appsettings.MapSyncMsg);
            return false;
          }
          else {
            if (DeviceDataid > 0) {              
              this.Device_Details.forEach(function (data) {
                if (data.DataId == DeviceDataid)
                {
                  deviceinfo = data;
                  Data_Id = deviceinfo.DataId;
                  Device_Type = deviceinfo.DeviceName
                }
                else
                {
                  Data_Id = DeviceDataid;
                }
              });  
              let getDeviceById: getDeviceById =
                { siteId:this.SiteId,
                  authKey: localStorage.getItem("Authkey"),
                  dataId:parseInt(Data_Id),
                  deviceType:Device_Type.toString(),
                  floorId:0,
                  isIndoor:1
                }            
              this.technologyoverlayService.getDeviceDetailsbyId(getDeviceById).pipe(takeUntil(this._onDestroy))
                .subscribe((Devicedetailsinfo: any[]) => {                  
                  if (Devicedetailsinfo != null && Devicedetailsinfo != undefined) {
                    this.edit_DeviceDetails(Devicedetailsinfo["apiReturn"][0], this.dialog, 0, this)
                  }
                })
            }
            else {              
              if(this.adddeviceflag == 1)
              {
                let Device_info = {DeviceName : Device_Type, CampusId : this.addcampusid, BuildId : this.addbuildingid, FloorId: this.addfloorid, UnitId : UnitId, UnitName : UnitName,
                  CampusName : this.Campus_Name, BuildingName : this.Building_Name, FloorName : this.Floor_Name,PolyPoints:verticesinfo,DeviceX:deviceX,DeviceY:deviceY,
                  MaxRexValue: this.MaxRexvalue,DataId:_DataId}
                  this.edit_DeviceDetails(Device_info, this.dialog, 1, this)
              }
              else
                this.edit_DeviceDetails(deviceinfo, this.dialog, 0, this)
            }
          }
        });

    }
    catch (err) {
      throw new Error('device.component.ts' + ' - edit_Devicedetails() - ' + err.message);
    }
  }

  edit_DeviceDetails(deviceinfo, dialog, addflag, _MapviewFloorComponent) {
    if (_MapviewFloorComponent.checkIsEditOpen == false) {
      _MapviewFloorComponent.checkIsEditOpen = true;
      var width = "37em";
      var height = "580px"
      
      localStorage.setItem("DeviceName", deviceinfo.DeviceName);
      _MapviewFloorComponent.deviceTypeName = localStorage.getItem("DeviceName");
      if (deviceinfo.DeviceName == 'UT') {
        width = "87rem";
        height = "740px";
      }
      
      let Devicedetails_info = {DeviceData : deviceinfo, AddDeviceflag : addflag}
      let dialogRef = dialog.open(EditDeviceComponent, {
        disableClose: true,
        width: width,
        height: height,
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: Devicedetails_info
      });
      dialogRef.afterClosed().subscribe(result => {
        _MapviewFloorComponent.checkIsEditOpen = false;
        if (result != "Cancel" && result != "addDevice") {
          var _btnEditSaveExists = document.getElementById('btnEditSaveExists');
          _btnEditSaveExists.click()
        }
        else if(result == "addDevice")
        {
          this.ResetButton();
          this.ClearDataRefresh();
        }
        else if(result == "Cancel")
        {
          let saveclick = document.getElementById('btnsaveclickmapview');
            saveclick.className = 'clsdeviceaddbutton mat-raised-button';
        }
      });
    }
  }

  EditSaveCall() {
    this.deviceTypeName = localStorage.getItem("DeviceName");
    var devicename = localStorage.getItem("DeviceName");
    if(devicename == DeviceTypeDesc.Rex || devicename == DeviceTypeDesc.HRex)
      {    
        this.technologyoverlayService.reloadiniltc(); 
        this.technologyoverlayService.systemreset_ltc();
     }
    if (devicename == DeviceTypeDesc.Pullcord) {
      this.technologyoverlayService.reloadPullCordConfig_ltc();
     
    }
    else if (devicename == DeviceTypeDesc.DC || devicename == DeviceTypeDesc.NewDC) {
      this.apiService.reload_DC_Config();
     
    }
    else if (devicename == DeviceTypeDesc.UT) {
      this.apiService.reloadDCTdevice();
    }
    else if (devicename != DeviceTypeDesc.Rex && devicename != DeviceTypeDesc.HRex && devicename != DeviceTypeDesc.Gateway) {
      this.apiService.reload_DrawRoom();
    }
    if (devicename == NewDeviceTypeDesc.Room) {
      if (localStorage.getItem("IsModifyYes") != "1")
        generateAlertMessage(this.dialog, appsettings.SaveSpace);
      this.Edit_pointsbool = true;
    }
    else if (devicename != null) {
      this.Edit_pointsbool = true;
      if (devicename == DeviceTypeDesc.Rex || devicename == DeviceTypeDesc.HRex) {
        if (localStorage.getItem("IsModifyYes") != "1")
          generateAlertMessage(this.dialog, appsettings.SaveDevice);
      }
      else {
        if (localStorage.getItem("IsModifyYes") != "1")
          generateAlertMessage(this.dialog, appsettings.SaveDevice);
      }
    }
    if (localStorage.getItem("IsModifyYes") != "1") {
      localStorage.removeItem("IsModifyYes");
      this.EditSaveExists();
    }
    else {
      localStorage.removeItem("IsModifyYes");
      //this.IsDuplicateAdded = parseInt(localStorage.getItem("UnitId"));
      this.IsDuplicateAdded = -1;
      this.ClearStoredData();
      this.getDeviceDetails();
    }    
  }

  EditSaveExists() {
    this.ResetButton();
    this.ClearDataRefresh();
  }

  ShowTemplateDetails() {
    var spaceId = parseInt(localStorage.getItem("SpaceId"));
    var SpaceName = localStorage.getItem("SpaceName");
    var UnitId = parseInt(localStorage.getItem("UnitId"));
    var floorId = this.addfloorid;
    var campusId = this.getfloordata.CampusId;
    var buildingId = this.getfloordata.BuildId;
    var floorName = this.getfloordata.FloorName;
    var floorPlanImage = this.getfloordata.FloorPlanImage;
    if (spaceId > 0) {

      let Spacedata = {
        SiteId: this.SiteId,
        AuthKey: localStorage.getItem("Authkey"),
        CampusId: campusId,
        BuildId: buildingId,
        FloorId: floorId,
        FloorName: SpaceName,
        UnitId: UnitId,
        mapfloorview: 1,
        FloorPlanImage:floorPlanImage
      }
      if (this.uniteditdialogopen == 0) {
        let dialogRef = this.dialog.open(TemplateUnitComponent, {
          disableClose: true,
          width: '35em',
          height: '640px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: Spacedata
        });
        this.uniteditdialogopen = 1;
        dialogRef.afterClosed().subscribe(result => {
          this.uniteditdialogopen = 0;
          let floorplanslistelement = document.getElementById('divfloorplandetails');
          if (floorplanslistelement != null)
            floorplanslistelement.className = 'clsenable';
        })
      }
    }
    else {

      let Floordata = {
        SiteId: this.SiteId,
        CampusId: campusId,
        BuildId: buildingId,
        FloorId: floorId,
        FloorName: floorName,
        FloorPlanImage:floorPlanImage
      }
      let dialogRef = this.dialog.open(TemplateZoneComponent, {
        disableClose: true,
        width: '35em',
        height: '640px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: Floordata
      });
      dialogRef.afterClosed().subscribe(result => {        
        let floorplanslistelement = document.getElementById('divfloorplandetails');
        if (floorplanslistelement != null)
          floorplanslistelement.className = 'clsenable';        
      })
    }

  }

  openFloorEditdialog() {

    if (!SessionCheck(this.router)) {
      return;
    }
        var _dialog = this.dialog;
      let mapsyncinfo : MapSyncProcess = 
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey")
      };
      this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
        .subscribe((MapSyncinfo: any[]) => {
          this.MapSyncProcess = MapSyncinfo
          if (this.MapSyncProcess == 1) {
            generateAlertMessage(_dialog, appsettings.MapSyncMsg);
            let floorplanslistelement = document.getElementById('divfloorplandetails');
            if (floorplanslistelement != null)
              floorplanslistelement.className = 'clsenable';
            return false;
          }
          else {
            this.formCampusId = this.getfloordata.FloorId;
            let floorbyid: ZoneByID = {
              siteId: this.SiteId,
              authKey: localStorage.getItem("Authkey"),
              zoneId: parseInt(this.getfloordata.FloorId)
            }

            this.technologyoverlayService.getZoneById(floorbyid).pipe(takeUntil(this._onDestroy))
              .subscribe((FloorByid: any[]) => {
                this.Edit_FloorById = FloorByid["apiReturn"];
                this.editflooropendialog(this.Edit_FloorById)
              });
          }
        })
  }

  editspaceClick()
  {
    document.getElementById('divEditSpaceMenu').style.display = "none";
    localStorage.setItem("Spaceedit","1");
  }

  editflooropendialog(FloorById) {
    try {
      var floorimage = FloorById[0].FloorPlanImage.split('.');
      var _floorsvgImage;
      var _floorimage;
      if (floorimage[1] == "svg" || floorimage[1] == "csv") {
        _floorsvgImage = FloorById[0].FloorPlanImage;
        _floorimage = "";
      }
      else {
        _floorimage = FloorById[0].FloorPlanImage;
        _floorsvgImage = "";
      }
      let floordetails: any = {
        CampusId: FloorById[0].CampusId,
        CampusName: FloorById[0].CampusName,
        BuildingName: FloorById[0].BuildingName,
        BuildId: FloorById[0].BuildId,
        FloorPlanImage: _floorimage,
        FloorPlansvgImage: _floorsvgImage,
        Description: FloorById[0].Description,
        FloorId: FloorById[0].FloorId,
        FloorName: FloorById[0].FloorName,
        FZoomLevel: FloorById[0].FZoomLevel,
        FRotateLevel: FloorById[0].FRotateLevel,
        FTransformX: FloorById[0].FTransformX,
        FTransformY: FloorById[0].FTransformY,
        Notifications : FloorById[0].Notifications,
        isResidentCheckin:FloorById[0].isResidentCheckin,
        bgImageWidth: FloorById[0].bgImageWidth,
        bgImageHeight: FloorById[0].bgImageHeight,
        OriginalFloorId : FloorById[0].OriginalFloorId,
        isZoneFloor : FloorById[0].isZoneFloor  
      }
      if (this.flooreditdialogopen == 0) {
        let dialogRef = this.dialog.open(EditZoneComponent, {
          disableClose: true,
          width: '75em',
          height:'850px',
          panelClass: 'myapp-no-padding-dialog',
          autoFocus: false,
          data: floordetails
        });
        this.flooreditdialogopen = 1;
        dialogRef.afterClosed().subscribe(result => {
          this.flooreditdialogopen = 0;
          
          if (result != "Cancel")
            this.FloorMapView(result.FloorId)
        })
      }
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - editflooropendialog() - ' + err.message);
    }
  }

  FloorMapView(result) {

    let floorbyid: ZoneByID = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      zoneId: parseInt(this.addfloorid)
    }
    this.technologyoverlayService.getZoneById(floorbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((FloorByid: any[]) => {
        this.ResetButton();
        this.ClearDataRefresh();
        if (getFeatureNeedtoShow(enumUIFeatureView.Technology,enumUIAction.Device_Map_AddEditDelete) == enumUIView.Hide) {
          this.DisableBtn();
        } 
      });

  }


  editunitopendialog(UnitByIddetails,dialog,_MapviewFloorComponent) {
    
    if (_MapviewFloorComponent.uniteditdialogopen == 0) {
      let dialogRef = dialog.open(EditUnitComponent, {
        disableClose: true,
        width: '87em',
        height: '700px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: UnitByIddetails
      });
      _MapviewFloorComponent.uniteditdialogopen = 1;
      dialogRef.afterClosed().subscribe(result => {
        _MapviewFloorComponent.uniteditdialogopen = 0;
        if (result != "Cancel") {
          _MapviewFloorComponent.SpaceMapView(result);
        }

      })
    }
  }

  SpaceMapView(result) {

    let floorbyid: UnitById = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      unitId: parseInt(result)
    }
    this.technologyoverlayService.getUnitById(floorbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((UnitByid: any[]) => {
        this.ResetButton();
        this.ClearDataRefresh();
      });

  }

  ClearInteraction() {
    var arr_Interactions = []

    try {
      this.map.getInteractions().forEach((interaction) => {
        if (interaction instanceof Translate) {
          //interaction.setActive(false);
          arr_Interactions[arr_Interactions.length] = interaction;
        }
        if (interaction instanceof Modify) {
          //interaction.setActive(false);
          arr_Interactions[arr_Interactions.length] = interaction;
        }
        if (interaction instanceof Select) {
          //interaction.setActive(false);
          arr_Interactions[arr_Interactions.length] = interaction;
        }
        if (interaction instanceof Draw) {
          //interaction.setActive(false);
          arr_Interactions[arr_Interactions.length] = interaction;
        }
      });

      for (var idx_int = 0; idx_int < arr_Interactions.length; idx_int++) {
        this.map.removeInteraction(arr_Interactions[idx_int]);
      }
      this.source.clear();
      this.map.removeLayer(this.vector);
      this.tempVectorSource.clear();
      this.map.removeLayer(this.tempVectorLayer);
    }
    catch (e) {
      console.log("ClearInteraction Error");
    }

    this.ClearDataRefresh();
  }

  DisableBtn() {
    document.getElementById('container_DeviceList').className = "disablebtn";
    document.getElementById('container_SelectMove').className = "disablebtn";
    document.getElementById('container_CreateSpace').className = "disablebtn";
    document.getElementById('container_EditSpace').className = "disablebtn";
    document.getElementById('container_AddDevice').className = "disablebtn";
    document.getElementById('container_Duplicate').className = "disablebtn";
    document.getElementById('container_InsertTemplate').className = "disablebtn";
    document.getElementById('container_DeleteSpace').className = "disablebtn";
  }

  DisableButton(Enable_Element) {
    document.getElementById('container_DeviceList').className = "disablebtn";
    document.getElementById('container_SelectMove').className = "disablebtn";
    document.getElementById('container_CreateSpace').className = "disablebtn";
    document.getElementById('container_EditSpace').className = "disablebtn";
    document.getElementById('container_AddDevice').className = "disablebtn";
    document.getElementById('container_Duplicate').className = "disablebtn";
    document.getElementById('container_InsertTemplate').className = "disablebtn";
    document.getElementById('container_DeleteSpace').className = "disablebtn";
    document.getElementById(Enable_Element).className = "enablebtn";

    if (Enable_Element != 'container_Duplicate' && Enable_Element != 'container_DeleteSpace') {
      this.ClearStoredData()
      this.uniteditdialogopen = 0;
      if (document.getElementById('btnShowTemplate')!=null) 
        document.getElementById("btnShowTemplate").innerHTML = "Save Zone As Template";
      document.getElementById("spnfloorName").innerHTML = document.getElementById("hdFloorName").innerHTML;
    }
  }

  EnableButton() {
    if (document.getElementById('container_DeviceList')!=null)
      document.getElementById('container_DeviceList').className = "enablebtn";

    if (document.getElementById('container_SelectMove')!=null)      
      document.getElementById('container_SelectMove').className = "enablebtn";
    if (document.getElementById('container_CreateSpace')!=null)      
      document.getElementById('container_CreateSpace').className = "enablebtn";
    if (document.getElementById('container_EditSpace')!=null)            
      document.getElementById('container_EditSpace').className = "enablebtn";
    if (document.getElementById('container_AddDevice')!=null)            
      document.getElementById('container_AddDevice').className = "enablebtn";
    if (document.getElementById('container_Duplicate')!=null)            
      document.getElementById('container_Duplicate').className = "enablebtn";
    if (document.getElementById('container_InsertTemplate')!=null)                  
      document.getElementById('container_InsertTemplate').className = "enablebtn";
    if (document.getElementById('container_DeleteSpace')!=null)            
      document.getElementById('container_DeleteSpace').className = "enablebtn";
  }

  ResetButton() {
    this.addcampusid = this.getfloordata.CampusId;
    this.addbuildingid = this.getfloordata.BuildId;
    this.addfloorid = this.getfloordata.FloorId;
    this.checkIsSpace = false;
    this.CheckIsAdd = false;
    this.checkIsEdit = false;
    this.checkIsEditOpen = false;
    this._translateend = 0;
    localStorage.setItem("CreateNew", "0");
    this.rotateIsInside = 1;
    this.EnableButton();

    let saveclick = document.getElementById('btnsaveclickmapview');
    if(saveclick != null)
    {
      saveclick.className = 'clsdeviceaddbutton mat-raised-button mat-primary';
      if (saveclick.innerHTML == "Done") saveclick.innerHTML = "Save";
    }

    if (document.getElementById('divEditSpaceMenu')!=null)
      document.getElementById('divEditSpaceMenu').style.display = "none";

    if (document.getElementById('divCreateSpaceMenu')!=null)
      document.getElementById('divCreateSpaceMenu').style.display = "none";
    if (document.getElementById('divDeviceList')!=null)
      document.getElementById('divDeviceList').style.display = "none";
  }

  ClearStoredData() {
    localStorage.removeItem("SpaceName");
    localStorage.removeItem("SpaceId");
    localStorage.removeItem("UnitId");
    localStorage.removeItem("DataId");
    localStorage.removeItem("RoomName");

    localStorage.removeItem("Polypoints");
    localStorage.removeItem("DeviceX");
    localStorage.removeItem("DeviceY");
    localStorage.removeItem("DeviceName");
    localStorage.removeItem("MultiDataId");
    localStorage.removeItem("MultiDeviceId");
    localStorage.removeItem("MultiFilterDeviceTypeId");
    localStorage.removeItem("IsDevice");
    localStorage.removeItem("DeviceTypeName");

    localStorage.removeItem("sel_DataId");
    localStorage.removeItem("Spaceedit");
    localStorage.removeItem("DeviceCount");
  }

  ClearDataRefresh() {
    this.getDeviceDetails();
    this.ClearStoredData();
    this.uniteditdialogopen = 0;
    if (document.getElementById("btnShowTemplate") !=null)
      document.getElementById("btnShowTemplate").innerHTML = "Save Zone As Template";

    if (document.getElementById("spnfloorName") !=null && document.getElementById("hdFloorName") !=null)
      document.getElementById("spnfloorName").innerHTML = document.getElementById("hdFloorName").innerHTML;
  }

  closeDrawFeature() {
    try {
      this.map.removeInteraction(this.draw);
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts - closeDrawFeature() - ' + err.message);
    }

  }

  //Draw feature for Devices
  DrawDeviceFeature(ImageDrawFeature_Type) {
    localStorage.setItem("DeviceTypeName", this.deviceTypeName);
    var DrawFeature_Type = "Point";
    var _addfloorid = this.addfloorid;
    var arr_Layers = this.map.getLayers();
    this.imageExtent = arr_Layers.array_[0].getSource().getImageExtent();

    this.checkdrawroomflag = 1;
    this.drawroomselect = 1;
    var imagescale = 0.25;
    this.tempVectorSource.clear();
    var fillcolorStyle = new Style({
      image: new Icon(/** @type {module:ol/style/Icon~Options} */({
        anchor: [15, 15],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        src: 'assets/images/' + ImageDrawFeature_Type,
        scale: imagescale
      }))
    });

    this.map.removeInteraction(this.draw);
    var drawSource;
    var drawVector;
    function onDrawStart(event) {
      //remove everything drawn previously
      drawSource.clear();
      
    }

    this.draw = new Draw({
      source: this.tempVectorSource,
      type: DrawFeature_Type,
      style: fillcolorStyle
    });

    this.draw.on('drawstart', onDrawStart);

    drawSource = this.tempVectorSource;

    this.tempVectorLayer = new OlVectorLayer({
      source: this.tempVectorSource,
      style: fillcolorStyle
    });

    this.tempVectorLayer.setStyle(fillcolorStyle);
    this.tempVectorLayer.set('extent', this.imageExtent);

    drawVector = this.tempVectorLayer;

    this.map.addInteraction(this.draw);
    this.map.addLayer(this.tempVectorLayer);

    var checkdraw;
    var _this = this;
    this.draw.on('drawend', function (e) {
      checkdraw = true;

      var IsPlaced = getNewFeature(_this.map, _this.dialog, e.feature, _addfloorid);
      if (IsPlaced == 0) {
        drawSource.clear();
        e.feature.values_.geometry.flatCoordinates = "";
      }
      else {
        e.feature.setStyle(fillcolorStyle);
        _this.map.removeInteraction(_this.draw);
      }
    });

    this.checkroomdrawend = checkdraw;

  }

  deleteUnit(deleteUnitId) {
    try {
     
      var DeviceCount = parseInt(localStorage.getItem("DeviceCount"));
     
      var Device_Count="";
      var message="";      
          
      if(DeviceCount > 0)   
      {
          message = "It contains ";
          Device_Count = DeviceCount + " Devices.";
      }
      
      var GeneralMessageData = {
        General_header:  "Delete Space ",                
        GeneralMessage:  "Are you sure you would like to delete this Space?<br> " + message + " <b>" + Device_Count + " </b>",
        General_first:  "Yes ",
        General_second:  "No"
      }  
      let dialogRef = this.dialog.open(GeneralMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '220px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: GeneralMessageData
      });
      
      dialogRef.afterClosed().subscribe(result => {     
        if(result == "First")
        {                     
            this.DeleteUnitbyId(deleteUnitId)         
        }
        else
        {                
          dialogRef.close('Cancel');          
          return;
        }
      });
            
    }
    catch (err) {
      throw new Error('mapview-floor.component.ts' + ' - deleteUnit - ' + err.message);
    }
  }
  
  DeleteUnitbyId(deleteUnitId)
  {
    var deleteunitById :deleteUnitById = {
      siteId: this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      unitId: parseInt(deleteUnitId)
    }
    this.ClearStoredData();
    this.uniteditdialogopen = 0;
    if (document.getElementById('btnShowTemplate')!=null) 
      document.getElementById("btnShowTemplate").innerHTML = "Save Zone As Template";
    document.getElementById("spnfloorName").innerHTML = document.getElementById("hdFloorName").innerHTML;

    this.technologyoverlayService.deleteUnit(deleteunitById).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: TechnologyForCreationResponse[]) => {

        if (apiresponse["apiReturn"].toString() == "Success") {
          generateAlertMessage(this.dialog, 'Space deleted successfully.');
          this.ResetButton();
          this.ClearDataRefresh();
        }
        else if (apiresponse["apiReturn"].toString() == "Fail") {
          generateAlertMessage(this.dialog, 'Space deleted failed ');
        }
        else if (apiresponse["apiReturn"] == "Invalid Auth Key") {
          this.thisDialogRef.close('close');
          AuthFailedMessage(this.dialog, this.router);
          return;
        }
        else {
          generateAlertMessage(this.dialog, apiresponse["apiReturn"].toString());
        }
        this.thisDialogRef.close();
      });
  }
  

  selectDeviceSort(sortType) {
    try
    {
      this.Device_Info = [];      
      this.selectedsortType = sortType;
      if (sortType == 1)
        this.getDeviceList_info.sort(this.sortByIRIDascending);
      else if (sortType == 2)
        this.getDeviceList_info.sort(this.sortByIRIDdescending);
      else if (sortType == 3)
        this.getDeviceList_info.sort(this.sortByRoomNameascending);
      else if (sortType == 4)
        this.getDeviceList_info.sort(this.sortByRoomNamedescending);

      this.Device_Info = this.getDeviceList_info;
      this.Total_DeviceInfo = this.getDeviceList_info.length;            
    }
    catch(err)
    {
      console.log("error : " + err.message)
      throw new Error('mapview-floor.component.ts' + ' - selectDeviceSort - ' + err.message);
    }
  }

  sortByIRIDascending(a: any, b: any) {
    if (a.Status > b.Status) return 1
    else if (a.Status === b.Status) return 0
    else return -1;
  }

  sortByIRIDdescending(a: any, b: any) {
    if (a.Status < b.Status) return 1
    else if (a.Status === b.Status) return 0
    else return -1;
  }

  sortByRoomNameascending(a: any, b: any) {
    if (a.UnitLocation.toLowerCase() > b.UnitLocation.toLowerCase()) return 1
    else if (a.UnitLocation.toLowerCase() === b.UnitLocation.toLowerCase()) return 0
    else return -1;
  }

  sortByRoomNamedescending(a: any, b: any) {
    if (a.UnitLocation.toLowerCase() < b.UnitLocation.toLowerCase()) return 1
    else if (a.UnitLocation.toLowerCase() === b.UnitLocation.toLowerCase()) return 0
    else return -1;
  }

  prevHoverfeature = null;
  mouseoverDevicedetails(deviceinfo) {
    var _this = this;

    var _DataId = deviceinfo.DataId;
    var _addfloorid = this.addfloorid;
    var arr_layer = [];
    this.map.getLayers().forEach(function (Floorlayer) {
      if (Floorlayer.get('FloorId') != undefined && Floorlayer.get('FloorId') == "Floor_" + _addfloorid) {
        arr_layer[arr_layer.length] = Floorlayer;
      }
    });
    for (var indx = 0; indx < arr_layer.length; indx++) {
      var features_device = arr_layer[indx].getSource().getFeatures();
      if (features_device) {
        // Go through this array and get coordinates of their geometry.
        features_device.forEach(function (feature) {
          if (parseInt(feature.getProperties().DataId) == parseInt(_DataId)
            && (feature.getProperties().geometry.flatCoordinates.length == 2)
            && parseInt(feature.getProperties().DeviceType) != 4) {

            if (_this.prevHoverfeature != null)
              mouseOnFeature(_this.prevHoverfeature, 0);

            mouseOnFeature(feature, 1);

            if (_this.prevHoverfeature != feature) {
              _this.prevHoverfeature = feature;
            }
          }
        });
      }
    }
    
    if (_DataId != null && _DataId != "0") {
      var space_deviceinfo = document.getElementsByClassName('deviceinfo_' + _DataId);
      var testDivs = Array.prototype.filter.call(space_deviceinfo, function (deviceElement) {
        deviceElement.style.background = "#d3d3d35e";
        return deviceElement;
      });
    }
    
  }

  mouseleaveDevicedetails(deviceinfo) {
    var _this = this;
    mouseOnFeature(_this.prevHoverfeature, 0);
    
    if (deviceinfo.DataId != null && deviceinfo.DataId != "0") {
      var space_deviceinfo = document.getElementsByClassName('deviceinfo_' + deviceinfo.DataId);
      var testDivs = Array.prototype.filter.call(space_deviceinfo, function (deviceElement) {
        deviceElement.style.background = "#ffffff";
        return deviceElement;
      });
    }
    
  }
  
  mouseoverrightsidemenu(rightmenu)
  {    
    var width = window.innerWidth;    
    if(width > 640)
    {
      if(rightmenu == enumTech_rightmenu_Tool.DeviceList)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_DeviceList;
      else if(rightmenu == enumTech_rightmenu_Tool.Move)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Move;
      else if(rightmenu == enumTech_rightmenu_Tool.Create_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Create_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Edit_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Edit_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Add_Device)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Add_Device;
      else if(rightmenu == enumTech_rightmenu_Tool.Duplicate_Space)
        document.getElementById("mouseovertext").innerHTML =appsettings.Tech_Duplicate_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Insert_Template)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Insert_Template;
      else if(rightmenu == enumTech_rightmenu_Tool.Delete_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Delete_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Rectangle_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Rectangle_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Ellipse_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Ellipse_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.FreeHand_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_FreeHand_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Edit_Point)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Edit_Point;
      else if(rightmenu == enumTech_rightmenu_Tool.Rotate_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Rotate_Space;
      else if(rightmenu == enumTech_rightmenu_Tool.Reflect_Space)
        document.getElementById("mouseovertext").innerHTML = appsettings.Tech_Reflect_Space;
    }
    else
    {
      document.getElementById("mouseovertext").innerHTML = " ";
    }
  }
  
  mouseleaverightsidemenu(value)
  {
    document.getElementById("mouseovertext").innerHTML = " ";
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
